import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import moment from 'moment';
import { WrappedStyled,
         InnerStyled,
         HiddenInput,
         SnackbarStyled,
         MenuStyled } from './styles';
import { ContentContext } from '~/_context';
import { CircularProgress } from '@mui/material';
import ReactPlayer from 'react-player';
import { CgCoffee } from "react-icons/cg";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { FaRegHandPointLeft } from "react-icons/fa";
import { PiCheckFatFill } from "react-icons/pi";


import { PiDotOutlineBold } from "react-icons/pi";
import { RxDotFilled } from "react-icons/rx";
import { MdOutlineClose } from "react-icons/md";

import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

import Countdown, { zeroPad } from 'react-countdown';
import { SiCoffeescript } from "react-icons/si";

/*
Neceisto un XLS de bocas de empresario columna dni + boca
*/



const BaristasContainer = () => {

  const { userData } = useContext(ContentContext);

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploadUiState, setUploadUiState] = useState('idle');
  const [clientPercent, setClientPercent] = useState(0);
  const [vimeoPercent, setVimeoPercent] = useState(0);
  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [ isLoadingVideo, setIsLoadingVideo ] = useState(false);
  const [ title, setTitle ] = useState("");
  const [ description, setDescription ] = useState("");
  const [ showPresentation, setShowPresentation ] = useState(true);

  const [ uploadEtapa1Open, setUploadEtapa1Open ] = useState(false);
  const [ uploadEtapa1Close, setUploadEtapa1Close ] = useState(false);
  const [ closeSelection, setCloseSelection ] = useState(false);
  const [ expertos, setExpertos ] = useState(null);
  const [ user, setUser ] = useState(null);
  
  const [ bocas, setBocas ] = useState([]);
  const [ isOpen, setIsOpen ] = useState(false);
  const [ bocaSelected, setBocaSelected ] = useState();

  const [ fileName, setFileName ] = useState("");
  const [ fileSize, setFileSize ] = useState("");
  const [ startUploading, setStartUploading ] = useState(false);
  const [ consignaEtapa1, setConsignaEtapa1 ] = useState(false);
  const [ consignaEtapa2, setConsignaEtapa2 ] = useState(false);
  const [ consignaEtapa3, setConsignaEtapa3 ] = useState(false);
  const [ videoEtapa1, setVideoEtapa1 ] = useState(null);
  const [ videoEtapa2, setVideoEtapa2 ] = useState(null);
  const [ videoEtapa3, setVideoEtapa3 ] = useState(null);
  const [ videoVotoEtapa1, setVideoVotoEtapa1 ] = useState(null);
  const [ videoSelectedEtapa1, setVideoSelectedEtapa1 ] = useState(null);
  const [ openSnack, setOpenSnack ] = useState(false);
  const [ snackMessage, setSnackMessage ] = useState("");
  const [ snackKey, setSnackKey ] = useState("");
  const [ scope, setScope ] = useState(null);
  const [ canVote, setCanVote ] = useState(true);
  const [ ownVoteEtapa1, setOwnVoteEtapa1 ] = useState(null);
  const [ votos, setVotos ] = useState([]);
  const [ baristaSelected, setBaristaSelected ] = useState(null);
  const [ haveBarista, setHaveBarista ] = useState(null);
  const [ videoToDisapprove, setVideoToDisapprove ] = useState(null);
  const [ conditionsViewedEtapa1, setConditionsViewedEtapa1 ] = useState(false);
  const [ conditionsViewedEtapa3, setConditionsViewedEtapa3 ] = useState(false);
  const [ errorVideosize, setErrorVideoSize ] = useState("");
  const [ bocasAll, setBocasAll ] = useState([]);
  const [ filterBoca, setFilterBoca ] = useState("");
  const [ filterStatus, setFilterStatus ] = useState("");
  const [ videoEtapa1Upload, setVideoEtapa1Upload ] = useState(false);
  const [ videoEtapa3Upload, setVideoEtapa3Upload ] = useState(false);
  const [ isVoting, setIsVoting ] = useState(false);
  const [ whatVoting, setWhatVoting ] = useState("");
  const [ showModalDisapprove, setShowModalDisapprove ] = useState([]);

  const [ disapproveReasons, setDisapproveReasons ] = useState({});
  const [ disapproveDescriptions, setDisapproveDescriptions ] = useState({});
  const [ disapproveErrors, setDisapproveErrors ] = useState({});
  const [ disapproveLoading, setDisapproveLoading ] = useState({});

  const [ whatShow, setWhatShow ] = useState("");
  const [ consignaEtapa, setConsignaEtapa ] = useState(false);
  const [ videoEtapa, setVideoEtapa ] = useState(null);
  const [ conditionsViewedEtapa, setConditionsViewedEtapa ] = useState(false);
  const [ videoEtapaUpload, setVideoEtapaUpload ] = useState(false);
  const [ videos, setVideos ] = useState(null);
  const [ ownVote, setOwnVote ] = useState(null);
  const [ etapaActiva, setEtapaActiva ] = useState(null);

  /* NUEVAS VARIABLES */
  const [ stageData, setStageData ] = useState(null);
  const [ showIngreso, setShowIngreso ] = useState(false);
  const [ isUploadActive, setIsUploadActive ] = useState(false);
  const [ showStatusVideo, setShowStatusVideo ] = useState(false);
  const [ titleFase, setTitleFase ] = useState('');
  const [ uploadVideoText, setUploadVideoText ] = useState('');
  const [ uploadVideoText1, setUploadVideoText1 ] = useState('');
  
  //const etapaActiva = 'etapa1';
  const upload_video_text = "¡Felicitaciones! Gracias a tu dedicación y talento, has avanzado a la Fase 3 de la Copa Barista."; //"¡Felicitaciones! Gracias a tu dedicación y talento, has avanzado a la Fase 2 de la Copa Barista.";//"¡Bienvenidos Expertos a la Copa Barista 2025!"; 
  const upload_video_text1 = "Del 28 de octubre al 4 de noviembre inclusive podés subir tu nuevo video."; //"A partir del 6 de al 19 de octubre inclusive podés subir tu nuevo video.";// "";
  
  // video etapa1
  //const video_consigna_fase_url = "https://vimeo.com/1229646710";
  
  // video etapa2
  //const video_consigna_fase_url = "https://vimeo.com/1236377537";

  // video etapa3
  const video_consigna_fase_url = "https://vimeo.com/1243357881";

  const textDateFase = '';//'En espera de validación para tu participación. A partir del 24 de septiembre sabrás el estado de tu video.';
  
  const fileInputRef = useRef(null);
  const uploadPollingRef = useRef(null);
  const uploadAbortControllerRef = useRef(null);
  const uploadCancelSourceRef = useRef(null);
  const clientPercentRef = useRef(0);
  const vimeoPercentRef = useRef(0);
  
  const final_date = new Date('2026-09-28 00:00:00');

  const baseURL = "https://fabianhr.com/protagonistas/baristas";
  //const baseURL = "https://fabianhr.com/protagonistas/baristas/staging";
  //const baseURL = "https://baristas.local:8890";

  const clampPercent = (value) => {
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return 0;
    }
    return Math.min(100, Math.max(0, numericValue));
  };

  const getCombinedProgress = (currentClientPercent, currentVimeoPercent) => {
    const safeClientPercent = clampPercent(currentClientPercent);
    const safeVimeoPercent = clampPercent(currentVimeoPercent);
    const total = safeClientPercent < 100
      ? safeClientPercent * 0.5
      : 50 + (safeVimeoPercent * 0.5);
    return clampPercent(Math.round(total));
  };

  const clearUploadPolling = () => {
    if (uploadPollingRef.current) {
      clearInterval(uploadPollingRef.current);
      uploadPollingRef.current = null;
    }
  };

  const clearUploadRequestRefs = () => {
    uploadAbortControllerRef.current = null;
    uploadCancelSourceRef.current = null;
  };

  const abortCurrentUpload = useCallback((resetToIdle = false) => {
    clearUploadPolling();

    if (uploadAbortControllerRef.current) {
      uploadAbortControllerRef.current.abort();
    }

    if (uploadCancelSourceRef.current) {
      uploadCancelSourceRef.current.cancel('Upload cancelado por el usuario.');
    }

    clearUploadRequestRefs();

    if (resetToIdle) {
      setIsLoadingVideo(false);
      setStartUploading(false);
      setUploadUiState('idle');
      setUploadStatus('Subida cancelada.');
    }
  }, []);

  const pollUploadProgress = useCallback((uploadId, cancelToken) => {
    clearUploadPolling();

    uploadPollingRef.current = setInterval(async () => {
      try {
        const response = await axios.get(`${baseURL}/upload.php`, {
          params: {
            action: 'progress',
            upload_id: uploadId,
          },
          cancelToken,
        });

        const progressData = response && response.data ? response.data : {};
        const status = progressData.status || '';
        const phase = progressData.phase || '';
        const nextVimeoPercent = clampPercent(progressData.percent_vimeo || 0);

        if (phase === 'server_to_vimeo' || phase === 'done' || status === 'completed') {
          vimeoPercentRef.current = nextVimeoPercent;
          setVimeoPercent(nextVimeoPercent);
          setUploadProgress(getCombinedProgress(clientPercentRef.current, nextVimeoPercent));
        }

        if (status === 'receiving_from_client') {
          setUploadUiState('uploading');
          setUploadStatus('Subiendo video al servidor...');
        }

        if (status === 'processing' || status === 'uploading_to_vimeo') {
          setUploadUiState('processing');
          setUploadStatus('Procesando y enviando video...');
        }

        if (status === 'failed') {
          clearUploadPolling();
          setIsLoadingVideo(false);
          setUploadUiState('failed');
          setUploadErrorMessage(progressData.error || 'El servidor devolvió un error al procesar el video.');
          setUploadStatus(progressData.error || 'El video no se pudo publicar, intentá nuevamente.');
          clearUploadRequestRefs();
        }

        if (status === 'completed') {
          clearUploadPolling();
          clientPercentRef.current = 100;
          vimeoPercentRef.current = 100;
          setClientPercent(100);
          setVimeoPercent(100);
          setUploadProgress(100);
          setIsLoadingVideo(false);
          setUploadUiState('completed');
          setUploadStatus('¡Video subido correctamente!');
          clearUploadRequestRefs();
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          return;
        }

        clearUploadPolling();
        setIsLoadingVideo(false);
        setUploadUiState('failed');
        setUploadErrorMessage('No se pudo consultar el progreso de la subida.');
        setUploadStatus('No se pudo consultar el progreso de la subida.');
        clearUploadRequestRefs();
      }
    }, 700);
  }, [baseURL]);


  const handleButtonBrowserClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    return () => {
      abortCurrentUpload(false);
    };
  }, [abortCurrentUpload]);

  const handleVideoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileSizeInBytes = file.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
      //console.log(`File size: ${fileSizeInMB.toFixed(2)} MB`);
      if(fileSizeInMB.toFixed(2) > 300){
        setErrorVideoSize(`El video que estas intentando cargar pesa ${fileSizeInMB.toFixed(2) + " mb"} recorda que el limite es de 300 mb.`);
      }else{
        setFileName(file.name);
        setFileSize(fileSizeInMB.toFixed(2) + " mb");
        setSelectedVideo(file);
      }
    }
    //console.log(event.target.files[0]);
    
  };

  let stage = 1;


  const handleUpload = (etapa) => {
    if (!selectedVideo) {
      return;
    }
    setStartUploading(true);
    setIsLoadingVideo(true);
    
    const formData = new FormData();
    formData.append('video', selectedVideo);
    formData.append('title', title);
    formData.append('description', description);
    

    axios.post(baseURL+'/upload.php', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        //console.log("percentage", percentage)
        setUploadProgress(percentage);
      },
    })
      .then((response) => {
        setIsLoadingVideo(false);
        setUploadStatus('¡Video subido correctamente!');

        if("uri" in response.data){
          let uri = response.data.uri.split("/");

          let eess = "";
          if("pos" in userData){
            if(userData.pos.length){
              eess = userData.pos[0].code;
            }
          }

          const payload = { id: user.id, uri: uri[2], etapa: etapa, title: title, description: description, boca: eess };
          saveVideo(payload);
        }
      })
      .catch((error) => {
        setIsLoadingVideo(false);
        setUploadStatus('El video  no se pudo publicar, intentá nuevamente.');
        console.error(error);
      });
      
  };
  
  /* INI UPLOAD TEST */
  /*
  const handleUpload = (etapa) => {
    console.log("🦄 handleUpload", etapa)
    //return null;
    setStartUploading(true);
    setIsLoadingVideo(false);
    setUploadStatus('¡Video subido correctamente!');
    setUploadProgress("100");
    
    let eess = "";
    if("pos" in userData){
      if(userData.pos.length){
        eess = userData.pos[0].code;
      }
    }

    const payload = { id: user.id, uri: '1001437876', etapa: etapa, title: 'Titulo video test', description: 'Descripción video test', boca: eess };
    console.log("🩵", payload);
    saveVideo(payload);
      
  };
  */
  /* END UPLOAD TEST */

  /*
  const handleUpload = (etapa) => {
    if (!selectedVideo) {
      return;
    }

    abortCurrentUpload(false);

    const uploadId = crypto.randomUUID();
    const abortController = new AbortController();
    const cancelSource = axios.CancelToken.source();

    abortController.signal.addEventListener('abort', () => {
      if (uploadCancelSourceRef.current) {
        uploadCancelSourceRef.current.cancel('Upload cancelado por AbortController.');
      }
    });

    uploadAbortControllerRef.current = abortController;
    uploadCancelSourceRef.current = cancelSource;

    setStartUploading(true);
    setIsLoadingVideo(true);
    setUploadUiState('uploading');
    setUploadErrorMessage('');
    setUploadStatus('Subiendo video al servidor...');
    setClientPercent(0);
    setVimeoPercent(0);
    setUploadProgress(0);
    clientPercentRef.current = 0;
    vimeoPercentRef.current = 0;

    pollUploadProgress(uploadId, cancelSource.token);
    
    const formData = new FormData();
    formData.append('video', selectedVideo);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('upload_id', uploadId);
    

    axios.post(baseURL+'/upload.php', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
      cancelToken: cancelSource.token,
      onUploadProgress: (progressEvent) => {
        const total = progressEvent.total || selectedVideo.size || 1;
        const percentage = clampPercent(Math.round((progressEvent.loaded / total) * 100));

        clientPercentRef.current = percentage;
        setClientPercent(percentage);
        setUploadProgress(getCombinedProgress(percentage, vimeoPercentRef.current));

        if (percentage < 100) {
          setUploadUiState('uploading');
          setUploadStatus('Subiendo video al servidor...');
        } else {
          setUploadUiState('processing');
          setUploadStatus('Archivo recibido. Procesando y enviando a Vimeo...');
        }
      },
    })
      .then((response) => {
        setUploadUiState('processing');
        setUploadStatus('Archivo recibido. Procesando y enviando a Vimeo...');

        if("uri" in response.data){
          let uri = response.data.uri.split("/");

          let eess = "";
          if("pos" in userData){
            if(userData.pos.length){
              eess = userData.pos[0].code;
            }
          }

          const payload = { id: user.id, uri: uri[2], etapa: etapa, title: title, description: description, boca: eess };
          saveVideo(payload);
        }
      })
      .catch((error) => {
        clearUploadPolling();

        if (axios.isCancel(error)) {
          setIsLoadingVideo(false);
          setUploadUiState('idle');
          setUploadStatus('Subida cancelada.');
          clearUploadRequestRefs();
          return;
        }

        setIsLoadingVideo(false);
        setUploadUiState('failed');
        setUploadErrorMessage('El video no se pudo publicar, intentá nuevamente.');
        setUploadStatus('El video no se pudo publicar, intentá nuevamente.');
        clearUploadRequestRefs();
        console.error(error);
      });
      
  };
  */

  const handleCancelUpload = () => {
    abortCurrentUpload(true);
  };
  













  /*

  const handleUpload = (etapa) => {
    if (!selectedVideo) {
      return;
    }
    setStartUploading(true);
    setIsLoadingVideo(true);
    const formData = new FormData();
    formData.append('video', selectedVideo);
    formData.append('title', title);
    formData.append('description', description);
    

    axios.post('https://fabianhr.com/protagonistas/baristas/upload.php', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        //console.log("percentage", percentage)
        setUploadProgress(percentage);
      },
    })
      .then((response) => {
        setIsLoadingVideo(false);
        setUploadStatus('¡Video subido correctamente!');

        if("uri" in response.data){
          let uri = response.data.uri.split("/");

          let eess = "";
          if("pos" in userData){
            if(userData.pos.length){
              eess = userData.pos[0].code;
            }
          }

          const payload = { id: user.id, uri: uri[2], etapa: etapa, title: title, description: description, boca: eess };
          saveVideo(payload);
        }
      })
      .catch((error) => {
        setIsLoadingVideo(false);
        setUploadStatus('El video  no se pudo publicar, intentá nuevamente.');
        console.error(error);
      });
  };
  */
  
  const handleSendVideo = () => {

  }

  const getUserData = useCallback(async (payload) => {

    //console.log("payload", payload)
    const requestURL = `${baseURL}/data.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/data.php`;
    //const requestURL = `https://baristas.local:8890/data.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }
    /*
     console.log("filter_boca", filterBoca);
    if("filter_boca" in payload){
      params.append("filter_boca", payload.filter_boca);
    }

    if("filter_status" in payload){
      params.append("filter_status", payload.filter_status);
    }
    */
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  const setBarista = useCallback(async (payload) => {
    const requestURL = `${baseURL}/setBarista.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/setBarista.php`;
    //const requestURL = `https://baristas.local:8890/setBarista.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  const setVideoViewed = useCallback(async (payload) => {
    const requestURL = `${baseURL}/setVideoViewed.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/setVideoViewed.php`;
    //const requestURL = `https://baristas.local:8890/setVideoViewed.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  
  const setConditionsViewed = useCallback(async (payload) => {
    const requestURL = `${baseURL}/setVideoViewed.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/setVideoViewed.php`;
    //const requestURL = `https://baristas.local:8890/setVideoViewed.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);
  
  
  const saveVideo = useCallback(async (payload) => {
    const requestURL = `${baseURL}/saveVideo.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/saveVideo.php`;
    //const requestURL = `https://baristas.local:8890/saveVideo.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  const saveApprove = useCallback(async (payload) => {
    const requestURL = `${baseURL}/saveApprove.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/saveApprove.php`;
    //const requestURL = `https://baristas.local:8890/saveApprove.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  const saveDisapprove = useCallback(async (payload) => {
    const requestURL = `${baseURL}/saveDisapprove.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/saveDisapprove.php`;
    //const requestURL = `https://baristas.local:8890/saveDisapprove.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  const saveDeleteResult = useCallback(async (payload) => {
    const requestURL = `${baseURL}/saveDeleteResult.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/saveDisapprove.php`;
    //const requestURL = `https://baristas.local:8890/saveDisapprove.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);

  const saveVote = useCallback(async (payload) => {
    
    const requestURL = `${baseURL}/saveVote.php`;
    //const requestURL = `https://fabianhr.com/protagonistas/baristas/saveVote.php`;
    //const requestURL = `https://baristas.local:8890/saveVote.php`;
    const params = new URLSearchParams()

    if(Object.keys(payload).length){
        Object.keys(payload).map(function(key) {
            params.append(key, payload[key]);
        })
    }

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    const result = await axios.post(requestURL, params, config);
    return result;

  }, []);
  
  

  /*
  const getUserData = useCallback(async (dni) => {
    const requestURL = `https://baristas.local:8890/data.php?dni=${dni}`;
    await axios.get(`${requestURL}`).then(result => { 
    console.log("result", result);
    }).catch(err => {
        //setHaveResponseError(true);
        //setHaveResponseErrorMessage(err.message);
    });
  }, []);
  */

  const handleSetBarista = (experto) => {
    
    setBaristaSelected(experto.id);
    //setHaveBarista(experto);
    //console.log("🚀", experto.id)
    
  }

  const handleSaveBarista = () => {
    
    const payload = {id: baristaSelected, boca: bocaSelected}
    console.log("🔥", payload)

    
    const barista_setted = setBarista(payload);
    barista_setted.then(res => {

      setSnackKey(uuidv4());
      setSnackMessage("El barista se seleccionó con éxito");
      setOpenSnack(true);
      
      const bocas_ = [...bocas];
      const bocasUpdater = bocas_.map(boca => {
        if(boca.value === bocaSelected){
          const experto = boca.expertos.map(exp => {
            
            if(exp.id === baristaSelected){
              setHaveBarista(exp);
              setExpertos(null);
              exp.is_barista = true;
            }else{
              exp.is_barista = false;
            }
          })
          //console.log("🚀", experto)
        }
        return boca;
      })
      //console.log("🔥", bocasUpdater)
      setBocas(bocasUpdater);

    })
    
  }

  const handleBoca = (e) => {
    if(e.target.value){
      const exp = bocas.filter(boca => boca.value === e.target.value);
      if(exp.length){
        const have_barista = exp[0].expertos.filter(exp => exp.is_barista === 1 || exp.is_barista === true);
        //console.log("have_barista", have_barista, exp[0].expertos)
        if(have_barista.length){
          setExpertos(null);
          setHaveBarista(have_barista[0]);
        }else{
          setHaveBarista(null);
          setExpertos(exp[0].expertos);
        }
      }
    }else{
      setExpertos(null);
    }
    setBocaSelected(e.target.value);
  }

  const handleStart = () => {
    //window.open("https://www.youtube.com/watch?v=yP4P8FH6whQ", '_blank').focus();
    setShowPresentation(false);
  }
  





  const [ onVideoEnded, setOnVideoEnded ] = useState(false);
  const _player = useRef(null);

  const handleOnReady = useCallback((e) => {

  }, []);
  const handleVideoSeek = useCallback((e) => {
  }, []);

  const handleVideoStop = useCallback(() => {

  }, []);

  const handleVideoStart = useCallback(() => {

  }, []);

  const handleVideoPlay = useCallback(() => {
    
  }, []);

  const onProgressVideoEndRef = useRef(false);
  const handleVideoProgress = useCallback((progress, etapa) => {
    //console.log("onVideoEnded", progress, onVideoEnded, onProgressVideoEnd);
    if(onProgressVideoEndRef.current === false && progress.played >= 0.95){
      onProgressVideoEndRef.current = true;
      //console.log("ENTRO");
      setOnVideoEnded(true);
      if((etapa === "etapa1" || etapa === "etapa2") && user?.id){
          const payload = {id: user.id, etapa: etapa};
          const response = setVideoViewed(payload);
          response.then(res => {
            setConsignaEtapa(true);
          })
      }
    };
  }, [setVideoViewed, user]);
  const handleVideoEnded = useCallback(() => {

  }, []);

  const reactPlayerConfig = useMemo(() => ({
    file: {
      attributes: {
        controlsList: 'nodownload'
      }
    },
    vimeo: {
      playerOptions: {
        controls: true,
        interactive_markers: false,
        interactive_params: false,
        vimeo_logo: false,
        play_button_position: "center",
        progress_bar: true,
        title: false,
      }
    }
  }), []);

  const handleApprove = useCallback((video_id, etapa) => {
    const payload = {video_id: video_id, etapa: etapa};
    const response = saveApprove(payload);
    response.then(res => {

      setSnackKey(uuidv4());
      setSnackMessage("El video se aprobó con éxito");
      setOpenSnack(true);

      setVideos(prevVideos => {
        if (!prevVideos) {
          return prevVideos;
        }

        return prevVideos.map(video => {
          if(video.id === video_id){
            return {
              ...video,
              // simplifico la lógica asumiendo que solo se aprueba una etapa a la vez por etapa
              approve_etapa: true,
            };
          }
          return video;
        });
      });
    })
  }, [saveApprove])

  const handleDisapprove = useCallback((etapa, formData) => {

    const payload = {video_id: formData.videoId, etapa: etapa, reason: formData.reasons.join(','), reason_description: formData.description};

    const response = saveDisapprove(payload);
    response.then(res => {
      setSnackKey(uuidv4());
      setSnackMessage("El video se desaprobó con éxito");
      setOpenSnack(true);

      setVideos(prevVideos => {
        if (!prevVideos) {
          return prevVideos;
        }

        return prevVideos.map(video => {
          if(video.id === formData.videoId){
            return {
              ...video,
              // simplifico la lógica asumiendo que solo se desaprueba una etapa a la vez por etapa
              reason_etapa: formData.reasons,
              reason_description_etapa: formData.description,
              approve_etapa: false,
            };
          }
          return video;
        });
      });
      setShowModalDisapprove(prev => prev.filter(id => id !== formData.videoId));

      setDisapproveLoading(prev => ({
        ...prev,
        [formData.videoId]: false
      }));

    })

    /*  
    const response = saveDisapprove(payload);
    response.then(res => {

      setSnackKey(uuidv4());
      setSnackMessage("El video se desaprobó con éxito");
      setOpenSnack(true);

      const videos_update = [...videos];
      const videos_update_ = videos_update.map(video => {
        if(video.id === videoToDisapprove){
          if(etapa === "etapa1"){
            video.reason_etapa1 = reason;
            video.arrpove_etapa1 = false;
          }
          if(etapa === "etapa2"){
            video.reason_etapa2 = reason;
            video.arrpove_etapa2 = false;
          }
          if(etapa === "etapa3"){
            video.reason_etapa3 = reason;
            video.arrpove_etapa3 = false;
          }
        }
        return video;
      })
      console.log("videos_update_", videos_update_)
      setVideos(videos_update_);
    })
    */
  }, [saveDisapprove])

  /*
  const handleDisapprove = (etapa, formData) => {
    console.log("handleDisapprove", formData)
    
    //console.log("video_id", videoToDisapprove, reason)
    
    setAnchorEl(null);
    const payload = {video_id: videoToDisapprove, etapa: etapa, reason: reason};
    //console.log("payload", payload);
    //return null;
    const response = saveDisapprove(payload);
    response.then(res => {

      setSnackKey(uuidv4());
      setSnackMessage("El video se desaprobó con éxito");
      setOpenSnack(true);

      const videos_update = [...videos];
      const videos_update_ = videos_update.map(video => {
        if(video.id === videoToDisapprove){
          if(etapa === "etapa1"){
            video.reason_etapa1 = reason;
            video.arrpove_etapa1 = false;
          }
          if(etapa === "etapa2"){
            video.reason_etapa2 = reason;
            video.arrpove_etapa2 = false;
          }
          if(etapa === "etapa3"){
            video.reason_etapa3 = reason;
            video.arrpove_etapa3 = false;
          }
        }
        return video;
      })
      //console.log("videos_update_", videos_update_)
      setVideos(videos_update_);
    })
    
  }
  */

  const handleSnackClose = () => {

    setOpenSnack(false);

  }

  const handleVote = (video_id, etapa, user_dni) => {

    setWhatVoting(video_id);
    setIsVoting(true);
    //return null;
    
    const payload = {video_id: video_id, etapa: etapa, dni: user_dni};
    const response = saveVote(payload);
    response.then(res => {

      setSnackKey(uuidv4());
      setSnackMessage("Tu voto se guardó con éxito");
      setOpenSnack(true);

      setOwnVote(video_id);
      setOwnVoteEtapa1(video_id);
      setCanVote(false);
      setVotos(res.data.votos);

    })

  }

  const getVotos = (video_id) => {

    return votos[video_id] ? votos[video_id] : 0;

  }

  const handleDownloadPDF = useCallback((pdf) => {

    switch (pdf) {
      case "condiciones":
        
        const payload = {id: user.id, etapa: etapaActiva};
        const response = setConditionsViewed(payload);
        response.then(res => {
          setConditionsViewedEtapa(true);
          setConsignaEtapa(true);
          //setConditionsViewedEtapa1(true);
        })
        
        setConditionsViewedEtapa(true);
        setConsignaEtapa(true);
        //setConditionsViewedEtapa1(true);
        //window.open('pdfs/Instructivo_video_Fase_1_Copa_Barista_2026.pdf', '_blank').focus();
        //window.open('pdfs/Instructivo_video_Fase_2_Copa_Barista_2026.pdf', '_blank').focus();
        window.open('pdfs/Instructivo_video_Fase_3_Copa_Barista_2026.pdf', '_blank').focus();
        break;
      case "instructivo":
        window.open('pdfs/Instructivo_Copa_Barista_2026.pdf', '_blank').focus();
        break;
      case "reglamento":
        window.open('pdfs/Reglamento_COPA_BARISTA_2026.pdf', '_blank').focus();
        break;
      case "faq":
        window.open('pdfs/Preguntas_frecuentes_COPA_BARISTA_2026.pdf', '_blank').focus();
        break;
      case "etapa2":
        setConditionsViewedEtapa1(true);
        //window.open('pdfs/Instructivo_Video_Fase_2.pdf', '_blank').focus();
        break;
      case "etapa3":
        setConditionsViewedEtapa3(true);
        //window.open('pdfs/Instructivo_Video_Fase_3.pdf', '_blank').focus();
        break;
      default:
        break;
    }

  }, [user, etapaActiva, setConditionsViewed])

  const handleChangeFilter = useCallback((e, name) => {
    console.log(name, e.currentTarget.value)
    switch (name) {
      case "status":
        setFilterStatus(e.currentTarget.value);
        break;
      case "boca":
        setBocaSelected(e.currentTarget.value.toString());
        setFilterBoca(e.currentTarget.value);
        break;
      default:
        break;
    }
    
  }, [])

  const handleFilter = useCallback(() => {

    // empresario: 33935989
    // experto basrista: 29504324 40243337 (Brito 35412589)
    // experto: 2088160
    // shell: 41472583

    const payload = {dni: userData.dni/*userData.dni*/, filter_boca: filterBoca, filter_status: filterStatus}
    const response = getUserData(payload);
    response.then(res => {
      setVideos(res.data.videos);
    })
    //getUserData(payload);

  }, [userData, filterBoca, filterStatus, getUserData])



  useEffect(() => {
    
    if(userData){
      if(Object.keys(userData).length){

        //console.log("userData", userData);
        
        // empresario: 33935989
        // experto basrista: 29504324 40243337 (Brito 35412589)
        // experto: 2088160
        // shell: 41472583 36215270

        const payload = {dni: userData.dni/*userData.dni*/}
        const response = getUserData(payload);
        response.then(res => {

            //if(res?.data?.stage){

                setEtapaActiva(res.data.stage.name);

                setStageData(res.data.stage);

                setScope(res.data.scope);
                setUser(res.data.user);
                //setCloseSelection(false);
                setIsOpen(true);
                setShowIngreso(true);

                setVideos(res.data.videos);

                switch (res.data.stage?.name) {
                  case 'inscripcion':
                    setTitleFase('Inscripción');
                    setUploadVideoText('¡Bienvenidos Expertos a la Copa Barista 2026!');
                    setUploadVideoText1('Del 28 de septiembre al 4 de octubre inclusive podés subir tu video.');
                    break;
                  case 'etapa1':
                    setTitleFase('Fase 1');
                    setUploadVideoText('¡Bienvenidos Expertos a la Copa Barista 2026!');
                    setUploadVideoText1('Del 28 de septiembre al 4 de octubre inclusive podés subir tu video.');
                    break;
                  case 'etapa1admin':
                    setTitleFase('Fase 1');
                    break;
                  case 'etapa2':
                    setTitleFase('Fase 2');
                    setUploadVideoText('¡Felicitaciones! Gracias a tu dedicación y talento, has avanzado a la Fase 2 de la Copa Barista.');
                    setUploadVideoText1('Del 16 de octubre al 27 de octubre inclusive podés subir tu video.');
                    break;
                  case 'etapa3':
                    setTitleFase('Fase 3');
                    setUploadVideoText('¡Felicitaciones! Gracias a tu dedicación y talento, has avanzado a la Fase 3 de la Copa Barista.');
                    setUploadVideoText1('Del 4 de noviembre al 11 de noviembre inclusive podés subir tu video.');
                    break;
                  default:
                    setTitleFase('');
                    setUploadVideoText('');
                    setUploadVideoText1('');
                    break;
                }
                //setVideoEtapaUpload(res.data.video_etapa_upload);//res.data.video_etapa1_upload

                if(res.data.user.role === "empresario"){

                    let arr_bocas = [{value: "", label: "Seleccioná una boca..."}];
                    res.data.bocas.map(boca => {
                      arr_bocas.push({value: boca.boca, label: boca.boca + " - " + boca.razon, expertos: boca.expertos});
                    })
                    
                    //setIsOpen(true);
                    setBocas(arr_bocas);

                    if(res.data.inscription_active){
                        setWhatShow("inscripcion");
                    }else{
                        setWhatShow("videogrid");
                    }
                }

                if(res.data.user.role === "experto"){

                    let eess = "";
                    let eess_razon = "";
                    if("pos" in userData){
                      if(userData.pos.length){
                        eess = userData.pos[0].code;
                        eess_razon = userData.pos[0].name;
                      }
                    }

                    let user_name = "";
                    let user_name_arr = [];

                    if(userData.name){
                      user_name_arr.push(userData.name);
                    }
                    if(userData.last_name){
                      user_name_arr.push(userData.last_name);
                    }
                    if(user_name_arr.length > 1){
                      user_name = user_name_arr.join(" ");
                    }

                    setTitle(`EESS ${eess} - ${eess_razon}` )
                    setDescription(`${user_name ? user_name + " - " : ""}DNI ${userData.dni ? userData.dni : ""}`);

                    if(res.data.user.is_barista){
                        setIsUploadActive(true);

                        setConsignaEtapa(res.data.user.consigna_etapa);
                        setVideoEtapa(res.data.user.video_etapa ? Object.keys(res.data.user.video_etapa).length ? res.data.user.video_etapa : null : null);
                        setConditionsViewedEtapa(res.data.user.video_etapa);
                        setVideoEtapaUpload(res.data.user.video_etapa_upload);

                        setWhatShow("uploader");
                    }else{
                        setWhatShow("videogrid");
                    }
                }

                if(res.data.user.role === "shell"){
                    setBocasAll(res.data.bocas_all);
                    setWhatShow("admin");
                }
                
            // }else{

            //     setShowIngreso(false);
                
            // }
            
            //setConsignaEtapa(res.data.user.consigna_etapa);

            /*
            if(res.data.stage.current !== null){
                switch (res.data.stage.current.name) {
                    case 'inscripcion':
                        if(res.data.user.role === "empresario"){
                            setShowIngreso(true);
                        }
                        //setMessageStatus("En breve veras el contenido correspondiente");
                        break;
                    case 'etapa1':
                    case 'etapa2':
                    case 'etapa3':
                        setShowIngreso(true);
                        if(res.data.user.role === "experto"){
                            if(res.data.user.is_barista){
                                setIsUploadActive(true);
                                setWhatShow("uploader");
                            }else{
                                setWhatShow("videogrid");
                            }
                        }
                        if(res.data.user.role === "empresario"){
                            setWhatShow("videogrid");
                        }
                        if(res.data.user.role === "shell"){
                            setWhatShow("admin");
                        }

                        break;
                    case 'etapa1admin':
                    case 'etapa2admin':
                    case 'etapa3admin':
                        setShowIngreso(true);
                        if(res.data.user.role === "experto"){
                            if(res.data.user.is_barista){
                                //setIsUploadActive(false);
                                //setWhatShow("uploader");
                                // Esta opcion es para mostrar el status del video del barista y que este ademas pueda ver el resto de los videos
                                setShowStatusVideo(true);
                                setWhatShow("videogrid");
                            }else{
                                setWhatShow("videogrid");
                            }
                        }
                        if(res.data.user.role === "empresario"){
                            setWhatShow("videogrid");
                        }
                        if(res.data.user.role === "shell"){
                            setWhatShow("admin");
                        }
                        break;
                    case 'etapa2':

                        
                        break;
                    case 'etapa2admin':
                        
                        break;
                    case 'etapa3':

                        break;
                    case 'etapa3admin':
                        
                        break;
                    default:
                        setIsUploadActive(false);
                        break;
                }
            }
            */

            /*
            if(res.data.user.role === "empresario"){
                if(res.data.stage.current.name === 'inscripcion'){
                    setWhatShow("inscripcion");
                }
            }

            if(res.data.user.role === "experto"){

                


                if(res.data.user.is_barista){

                    if(res.data.stage.current !== null && !String(res.data.stage.current.name).toLowerCase().includes("admin")){
                        setIsUploadActive(true);
                        setWhatShow("uploader");
                    }else{
                        setIsUploadActive(false);
                    }

                }else{
                    setWhatShow("videogrid");
                }
            }

            if(res.data.user.role === "shell"){

            }
            */



        /*
          //setCloseSelection(res.data.close_selection);
          //setUploadEtapa1Open(res.data.upload_etapa1_open);
          //setUploadEtapa1Close(res.data.upload_etapa1_close);
          //setVideoEtapa1Upload(res.data.video_etapa1_upload);
          

          if(res.data.user.role === "empresario"){
            //setExpertos(res.data.expertos);
            let arr_bocas = [{value: "", label: "Seleccioná una boca..."}];
            res.data.bocas.map(boca => {
              arr_bocas.push({value: boca.boca, label: boca.boca + " - " + boca.razon, expertos: boca.expertos});
            })
            
            //setIsOpen(true);
            setBocas(arr_bocas);
          }

          //console.log("res.data", res.data);

          if(res.data.scope === "etapa1"){
            if(res.data.user.is_barista){
                setConsignaEtapa(res.data.user.consigna_etapa1);
                setVideoEtapa(res.data.user.videp_etapa1 ? Object.keys(res.data.user.videp_etapa1).length ? res.data.user.videp_etapa1 : null : null);
                setConditionsViewedEtapa(res.data.user.videp_etapa1 ? true : false);
                setVideoEtapaUpload(res.data.video_etapa1_upload);
                setWhatShow("uploader");
            }else{
              if(res.data.user.role !== "empresario"){
                setWhatShow("empresario");
              }
            }
          }

          if(res.data.scope === "etapa2"){
            if(res.data.user.is_selected){
              setWhatShow("uploader");
            }else{
              if(res.data.user.role !== "shell"){
                setVideos(res.data.videos);
                setWhatShow("videogrid");
              }else{
                setWhatShow("admin");
              }
            }
            
            //if(res.data.user.is_barista){
              //console.log("ETAPA 2");

              setConsignaEtapa(res.data.user.consigna_etapa2);
              setVideoEtapa(res.data.user.videp_etapa2 ? Object.keys(res.data.user.videp_etapa2).length ? res.data.user.videp_etapa2 : null : null);
              setConditionsViewedEtapa(res.data.user.videp_etapa2 ? true : false);
              setVideoEtapaUpload(res.data.video_etapa2_upload);

              let eess = "";
              let eess_razon = "";
              if("pos" in userData){
                if(userData.pos.length){
                  eess = userData.pos[0].code;
                  eess_razon = userData.pos[0].name;
                }
              }

              let user_name = "";
              let user_name_arr = [];

              if(userData.name){
                user_name_arr.push(userData.name);
              }
              if(userData.last_name){
                user_name_arr.push(userData.last_name);
              }
              if(user_name_arr.length > 1){
                user_name = user_name_arr.join(" ");
              }

              setTitle(`EESS ${eess} - ${eess_razon}` )
              setDescription(`${user_name ? user_name + " - " : ""}DNI ${userData.dni ? userData.dni : ""}`);


            //}
          }

          if(res.data.scope === "vote"){
            //setIsOpen(true);
            //setVideoVotoEtapa1(res.data.videos);

            setWhatShow("vote");
            setVideos(res.data.videos);
            setCanVote(!res.data.own_vote ? true : false);

            if(res.data.user.role === "shell"){
              setCanVote(false);
              setWhatShow("admin");
            }else{
              if(res.data.user.is_barista){
                setConsignaEtapa(res.data.user.consigna_etapa1);
                setVideoEtapa(res.data.user.videp_etapa1 ? Object.keys(res.data.user.videp_etapa1).length ? res.data.user.videp_etapa1 : null : null);
                setConditionsViewedEtapa(res.data.user.videp_etapa1 ? true : false);
                setVideoEtapaUpload(res.data.video_etapa1_upload);
                setWhatShow("uploader");
              }
              
              //else{
              //  if(res.data.user.role === "empresario"){
              //    setWhatShow("vote");
              //  }
                //setCanVote(!res.data.own_vote ? true : false);
              //}
              
            }
            setOwnVote(res.data.own_vote ? res.data.own_vote : null);
            //setOwnVoteEtapa1(res.data.own_vote ? res.data.own_vote : null);
          }

          
//          if(res.data.user.role === "experto"){

            //setIsOpen(true);
            //setIsOpen(res.data.is_open);

//            if(res.data.user.is_barista){

//              setConsignaEtapa1(res.data.user.consigna_etapa1);
//              setConsignaEtapa2(res.data.user.consigna_etapa2);
              //setVideoEtapa1(res.data.user.videp_etapa1 ? Object.keys(res.data.user.videp_etapa1).length ? true : null : null);
              //setVideoEtapa2(res.data.user.videp_etapa2 ? Object.keys(res.data.user.videp_etapa2).length ? true : null : null);
//              setVideoEtapa1(res.data.user.videp_etapa1 ? Object.keys(res.data.user.videp_etapa1).length ? res.data.user.videp_etapa1 : null : null);
//              setVideoEtapa2(res.data.user.videp_etapa2 ? Object.keys(res.data.user.videp_etapa2).length ? res.data.user.videp_etapa2 : null : null);
//              setConditionsViewedEtapa1(res.data.user.videp_etapa1 ? true : res.data.user.consigna_etapa1 ? true : false);
//              let eess = "";
//              let eess_razon = "";
//              if("pos" in userData){
//                if(userData.pos.length){
//                  eess = userData.pos[0].code;
//                  eess_razon = userData.pos[0].name;
//                }
//              }
//
//              let user_name = "";
//              let user_name_arr = [];
//
//              if(userData.name){
//                user_name_arr.push(userData.name);
//              }
//              if(userData.last_name){
//                user_name_arr.push(userData.last_name);
//              }
//              if(user_name_arr.length > 1){
//                user_name = user_name_arr.join(" ");
//              }

//              setTitle(`EESS ${eess} - ${eess_razon}` )
//              setDescription(`${user_name ? user_name + " - " : ""}DNI ${userData.dni ? userData.dni : ""}`);
              //setDescription(`Copa Baristas - Etapa 1 - EESS ${eess} - ${eess_razon} - DNI ${userData.dni}`);

//            }
//          }

//          if(res.data.user.is_selected){
//            console.log("ES BARISTA");
            //console.log("res.data.user", res.data.user)
//            setConsignaEtapa1(res.data.user.consigna_etapa2);
//            setVideoEtapa1(res.data.user.videp_etapa2 ? Object.keys(res.data.user.videp_etapa2).length ? res.data.user.videp_etapa2 : null : null);
//            setConditionsViewedEtapa1(res.data.user.videp_etapa2 ? true : false);
//            setVideoEtapa1Upload(res.data.video_etapa2_upload);
//            let eess = "";
//              let eess_razon = "";
//              if("pos" in userData){
//                if(userData.pos.length){
//                  eess = userData.pos[0].code;
//                  eess_razon = userData.pos[0].name;
//                }
//              }
//
//              let user_name = "";
//              let user_name_arr = [];
//
//              if(userData.name){
//                user_name_arr.push(userData.name);
//              }
//              if(userData.last_name){
//                user_name_arr.push(userData.last_name);
//              }
//              if(user_name_arr.length > 1){
//                user_name = user_name_arr.join(" ");
//              }
//
//              setTitle(`EESS ${eess} - ${eess_razon}` )
//              setDescription(`${user_name ? user_name + " - " : ""}DNI ${userData.dni ? userData.dni : ""}`);
//          }
//
//          if(res.data.user.is_winner){
//
//            setConsignaEtapa3(res.data.user.consigna_etapa3);
//            setVideoEtapa3(res.data.user.videp_etapa3 ? Object.keys(res.data.user.videp_etapa3).length ? res.data.user.videp_etapa3 : null : null);
//            setConditionsViewedEtapa3(res.data.user.videp_etapa3 ? true : false);
//            setVideoEtapa3Upload(res.data.video_etapa3_upload);
//            let eess = "";
//              let eess_razon = "";
//              if("pos" in userData){
//                if(userData.pos.length){
//                  eess = userData.pos[0].code;
//                  eess_razon = userData.pos[0].name;
//                }
//              }
//
//              let user_name = "";
//              let user_name_arr = [];
//
//              if(userData.name){
//                user_name_arr.push(userData.name);
//              }
//              if(userData.last_name){
//                user_name_arr.push(userData.last_name);
//              }
//              if(user_name_arr.length > 1){
//                user_name = user_name_arr.join(" ");
//              }
//
//              setTitle(`EESS ${eess} - ${eess_razon}` )
//              setDescription(`${user_name ? user_name + " - " : ""}DNI ${userData.dni ? userData.dni : ""}`);
//
          //}

          

          if(res.data.scope === "etapa3"){

            let eess = "";
            let eess_razon = "";
            if("pos" in userData){
              if(userData.pos.length){
                eess = userData.pos[0].code;
                eess_razon = userData.pos[0].name;
              }
            }

            let user_name = "";
            let user_name_arr = [];

            if(userData.name){
              user_name_arr.push(userData.name);
            }
            if(userData.last_name){
              user_name_arr.push(userData.last_name);
            }
            if(user_name_arr.length > 1){
              user_name = user_name_arr.join(" ");
            }
            
            setTitle(`EESS ${eess} - ${eess_razon}` )
            setDescription(`${user_name ? user_name + " - " : ""}DNI ${userData.dni ? userData.dni : ""}`);
            
            setVideos(res.data.videos);
            setWhatShow("videogrid");
            
            //if(res.data.user.is_finalist){
            //    setConsignaEtapa(res.data.user.consigna_etapa3);
            //    setVideoEtapa(res.data.user.videp_etapa3 ? Object.keys(res.data.user.videp_etapa3).length ? res.data.user.videp_etapa3 : null : null);
            //    setConditionsViewedEtapa(res.data.user.videp_etapa3 ? true : false);
            //    setVideoEtapaUpload(res.data.video_etapa3_upload);
            //    setWhatShow("uploader");
            //}else{

            //  setVideos(res.data.videos);
            //  if(res.data.user.role !== "shell"){
            //    setVideos(res.data.videos);
            //    setWhatShow("videogrid");
            //  }else{
            //    setWhatShow("admin");
            //  }
              

              
              //setWhatShow("videogrid");
              
              // if(res.data.user.role !== "empresario"){
              //   setWhatShow("empresario");
              // }
              
            //}
            
          }

          

          if(res.data.user.role === "shell"){
            //setIsOpen(true);

            //console.log("res.data.videos", res.data.videos)
            setVideos(res.data.videos);
            setBocasAll(res.data.bocas_all);
          }
          
          if(res.data.scope === "etapa2"){
            setVideoSelectedEtapa1(res.data.videos);
          }

          if(res.data.scope === "etapa3"){
            //setVideoSelectedEtapa1(res.data.videos);
          }
          
          setVotos(res.data.votos);

          */

        })
        
        
      }
    }
    return () => {}
  }, [userData])
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = useCallback((event, video_id) => {

    setShowModalDisapprove(prev => {
      if (prev.includes(video_id)) {
        return prev;
      }
      return [...prev, video_id];
    });

    setVideoToDisapprove(video_id);
    //setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCanVote = (canVote, videoEtapa1, video_id) => {
    if(videoEtapa1 === null){
      return canVote;
    }else{
      //return false;
      
      if(videoEtapa1.id !== video_id){
        return true;
      }else{
        return false;
      }
      
    }
    //canVote
    //(videoEtapa1 !== null && videoEtapa1.id !== video.id)

  }

  const handleOnCompleteCountDown = () => {
    //alert("LLEGO A CERO")
  }



  const handleDeleteResult = useCallback((video_id) => {

    const payload = {video_id: video_id, etapa: etapaActiva};
    //return null;
    //saveDeleteResult(videoId)

    const response = saveDeleteResult(payload);
    response.then(res => {
      setSnackKey(uuidv4());
      setSnackMessage("El video se restauró con éxito");
      setOpenSnack(true);

      setVideos(prevVideos => {
        if (!prevVideos) {
          return prevVideos;
        }

        return prevVideos.map(video => {
          if(video.id === video_id){
            return {
              ...video,
              // simplifico la lógica asumiendo que solo se restaura una etapa a la vez por etapa
              reason_etapa: [],
              reason_description_etapa: "",
              arrpove_etapa: false,
              approve_etapa: null,
            };
          }
          return video;
        });
      });
      /*
      setShowModalDisapprove(showModalDisapprove.filter(id => id !== formData.videoId));

      setDisapproveLoading(prev => ({
        ...prev,
        [formData.videoId]: false
      }));
      */

    })

  }, [etapaActiva, saveDeleteResult])

  // Función para manejar cambios en los checkboxes
  const handleReasonChange = useCallback((videoId, reason, checked) => {

    setDisapproveReasons(prev => ({
      ...prev,
      [videoId]: {
        ...prev[videoId],
        [reason]: checked
      }
    }));

    if (checked) {
      setDisapproveErrors(prev => ({
        ...prev,
        [videoId]: false
      }));
    }

  }, []);

  // Función para manejar cambios en el textarea
  const handleDescriptionChange = useCallback((videoId, description) => {
    setDisapproveDescriptions(prev => ({
      ...prev,
      [videoId]: description
    }));
  }, []);

  // Modificar la función handleConfirmDisapprove
  const handleConfirmDisapprove = useCallback(async (videoId) => {

    const reasons = disapproveReasons[videoId] || {};
    const description = disapproveDescriptions[videoId] || '';
    
    const selectedReasons = Object.keys(reasons).filter(reason => reasons[reason]);
    
    // Validar que al menos una razón esté seleccionada
    // if (selectedReasons.length === 0) {
    //   setDisapproveErrors(prev => ({
    //     ...prev,
    //     [videoId]: true
    //   }));
      
    //   // Hacer que el error desaparezca después de 2 segundos
    //   setTimeout(() => {
    //     setDisapproveErrors(prev => ({
    //       ...prev,
    //       [videoId]: false
    //     }));
    //   }, 2000);
      
    //   return; // No continuar si no hay razones seleccionadas
    // }

    setDisapproveLoading(prev => ({
      ...prev,
      [videoId]: true
    }));

    const formData = {
      videoId: videoId,
      reasons: selectedReasons,
      description: description
    };
    /*
    try {
      await handleDisapprove('etapa1', formData);
      console.log('Datos del formulario:', formData);
      
      // Limpiar el estado para este video
      setDisapproveReasons(prev => ({
        ...prev,
        [videoId]: {}
      }));
      setDisapproveDescriptions(prev => ({
        ...prev,
        [videoId]: ''
      }));
      
      // Cerrar el modal
      console.log("🐹🐹🐹🐹🐹")
      
    } catch (error) {
      console.error('Error al desaprobar video:', error);
    } finally {
      console.log("🐸🐸🐸🐸🐸")
      // Ocultar loading
      setShowModalDisapprove(showModalDisapprove.filter(id => id !== videoId));
      setDisapproveLoading(prev => ({
        ...prev,
        [videoId]: false
      }));
    }
    */
    
    handleDisapprove(etapaActiva, formData);
    
    setDisapproveReasons(prev => ({
      ...prev,
      [videoId]: {}
    }));
    setDisapproveDescriptions(prev => ({
      ...prev,
      [videoId]: ''
    }));
    
    //setShowModalDisapprove(showModalDisapprove.filter(id => id !== videoId));
    
  }, [disapproveReasons, disapproveDescriptions, etapaActiva, handleDisapprove]);

  const handleCloseDisapproveModal = useCallback((videoId) => {
    setShowModalDisapprove(prev => prev.filter(id => id !== videoId));
  }, []);


  useEffect(() => {
    console.log("🎃🎃🎃", bocas)
    console.log("🌈🌈🌈", expertos)
  }, [bocas, expertos]);
  useEffect(() => {

    console.log("🎁🎁🎁🎁🎁", !startUploading, !videoEtapa, videoEtapaUpload);
    console.log("☘️☘️☘️☘️☘️", !conditionsViewedEtapa && videoEtapaUpload);
    //console.log("whatShow", whatShow, etapaActiva)
    //console.log("videoEtapa1", videoEtapa1)
  
    return () => {}
  }, [startUploading, videoEtapa, videoEtapaUpload, conditionsViewedEtapa, videoEtapaUpload])

    const Admin = useMemo(() => (
        <div className='box_approve_video'>
          <div className='inner'>
            <div className='intro_text'>Una vez aprobado o desaprobado, el video no podrá ser modificado. Por favor, asegúrese de su decisión antes de proceder.</div>

            <div className='filter_videos'>
              <div className='select_bocas'>
                <label>EESS:</label>
                <select onChange={(e) => handleChangeFilter(e, "boca")}>
                  <option value="">Seleccionar una opción</option>
                  {bocasAll.map(boca => {
                    return(
                      <option value={boca.boca} selected={boca.boca === bocaSelected}>{`${boca.boca} - ${boca.razon}`}</option>
                    )
                  })}
                </select>
              </div>
              <div className='select_status'>
                <label>Estado:</label>
                <select onChange={(e) => handleChangeFilter(e, "status")}>
                  <option value="">Seleccionar una opción</option>
                  <option value="approved">Aprobado</option>
                  <option value="disapproved">Desaprobado</option>
                  <option value="pending">Pendiente</option>
                </select>
              </div>
              <div className='bt_gray bt_filter' onClick={handleFilter}>
                <p>Filtrar</p>
              </div>
            </div>

            <div className='box_video_list'>

                
                
                {videos === null ? <>cargando</> : ""}
                {videos !== null && videos.length ?
                <div className='video_elements'>
                  {videos.map(video => {
                    return(
                        
                        
                        <div className='video_element'>
                          
                          {showModalDisapprove.includes(Number(video.id)) ? 
                            <div className='box_disapprove'>
                              {disapproveErrors[video.id] && (
                                <div className='box_disapprove_error'>Para continuar, seleccione un motivo de desaprobación.</div>
                              )}
                              <div className='disapprove_reasons'>
                                <div className='title'>Desaprobación de video</div>
                                <div className='description'>Por favor, seleccione el motivo de la desaprobación del video.</div>
                                {/*
                                <div className='reasons'>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason1_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="espresso_perfecto"
                                      checked={disapproveReasons[video.id]?.espresso_perfecto || false}
                                      onChange={(e) => handleReasonChange(video.id, 'espresso_perfecto', e.target.checked)}
                                    />
                                    <label htmlFor={`reason1_${video.id}`}>Espresso perfecto</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason2_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="presentacion_personal"
                                      checked={disapproveReasons[video.id]?.presentacion_personal || false}
                                      onChange={(e) => handleReasonChange(video.id, 'presentacion_personal', e.target.checked)}
                                    />
                                    <label htmlFor={`reason2_${video.id}`}>Presentación personal</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason3_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="especificaciones_tecnicas"
                                      checked={disapproveReasons[video.id]?.especificaciones_tecnicas || false}
                                      onChange={(e) => handleReasonChange(video.id, 'especificaciones_tecnicas', e.target.checked)}
                                    />
                                    <label htmlFor={`reason3_${video.id}`}>Especificaciones técnicas</label>
                                  </div>
                                </div>
                                */}
                                <div className='reasons'>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason1_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="emulsion_de_leche"
                                      checked={disapproveReasons[video.id]?.emulsion_de_leche || false}
                                      onChange={(e) => handleReasonChange(video.id, 'emulsion_de_leche', e.target.checked)}
                                    />
                                    <label htmlFor={`reason1_${video.id}`}>Emulsión de la leche</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason2_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="oratoria_y_transmision_al_equipo"
                                      checked={disapproveReasons[video.id]?.oratoria_y_transmision_al_equipo || false}
                                      onChange={(e) => handleReasonChange(video.id, 'oratoria_y_transmision_al_equipo', e.target.checked)}
                                    />
                                    <label htmlFor={`reason2_${video.id}`}>Oratoria, explicación y calidad de video</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason3_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="latte_art"
                                      checked={disapproveReasons[video.id]?.latte_art || false}
                                      onChange={(e) => handleReasonChange(video.id, 'latte_art', e.target.checked)}
                                    />
                                    <label htmlFor={`reason3_${video.id}`}>Latte Art</label>
                                  </div>
                                </div>
                                <div className='reason_description'>
                                  <label>Descripción:</label>
                                  <textarea
                                    value={disapproveDescriptions[video.id] || ''}
                                    onChange={(e) => handleDescriptionChange(video.id, e.target.value)}
                                    placeholder="Ingrese una descripción detallada..."
                                  />
                                </div>
                              </div>
                              
                              {disapproveLoading[video.id] ? (
                                <div className='loader'>
                                  <CircularProgress size={30} />
                                  <span>Procesando...</span>
                                </div>
                              ) : (
                                <div className='actions'>
                                  <div className='bt_gray bt_confirm' onClick={() => handleConfirmDisapprove(video.id)}>
                                    <p>Confirmar</p>
                                  </div>
                                  <div className='bt_gray bt_cancel' onClick={() => handleCloseDisapproveModal(video.id)}>
                                    <p>Cancelar</p>
                                  </div>
                                </div>
                              )}
      
                            </div> 
                          : ""}

                          <div className='video'>
                          
                            <ReactPlayer
                              ref={_player}
                              className={`react-player`}
                              playing={false}
                              url={`https://vimeo.com/${video.video_id}`}
                              width='100%'
                              height='100%'
                              controls={true}
                              onProgress={(progress) => { handleVideoProgress(progress)}}
                              onReady={handleOnReady}
                              onPlay={handleVideoPlay}
                              onStart={handleVideoStart}
                              onStop={handleVideoStop}
                              onEnded={handleVideoEnded}
                              onSeek={handleVideoSeek}
                              config={{ 
                                file: {
                                  attributes: {
                                    controlsList: 'nodownload'  //<- this is the important bit
                                  }
                                },
                                vimeo: {
                                  playerOptions: {
                                    interactive_markers: false,
                                    interactive_params: false,
                                    vimeo_logo: false,
                                    play_button_position: "center",
                                    progress_bar: true,
                                    title: false,
                                    //responsive: true
                                  }
                                }
                              }}
                            />
                          
                          </div>
                          <div className='data'>
                            <div className='title'>{video.title}</div>
                            <div className='description'>{video.description}</div>
                            {video.approve_etapa === null ? 
                            (user.dni !== '45235819' && user.dni !== '30328358') && (
                            <div className='actions'>
                                
                                <div className='bt_gray bt_approve' onClick={() => handleApprove(video.id, etapaActiva)}>
                                  <p>APROBAR</p>
                                </div>
                                
                                <div className='bt_gray bt_disapprove' id="basic-button" onClick={(e) => handleClick(e, video.id)}>
                                  <p>DESAPROBAR</p>
                                </div>
          
                            </div>
                            )
                            :
                            video.approve_etapa ? 
                            <div className='box_shell_approve'>
                              <div className='bt_delete_result' onClick={() => handleDeleteResult(video.id)}><MdOutlineClose /></div>
                              Aprobado
                            </div>
                            :
                            <div className='box_shell_disapprove'>
                              <div className='bt_delete_result' onClick={() => handleDeleteResult(video.id)}><MdOutlineClose /></div>
                              {video.reason_etapa?.length === 0 && video.approve_etapa === false ? "Desaprobado" : ""}
                              {/* <ul>
                                {video?.reason_etapa?.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                                {video?.reason_etapa?.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                                {video?.reason_etapa?.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                              </ul> */}
                              <ul>
                                {video.reason_etapa?.includes("emulsion_de_leche") ? <li><RxDotFilled /> <div> Emulsión de la leche</div></li> : ""}
                                {video.reason_etapa?.includes("oratoria_y_transmision_al_equipo") ? <li><RxDotFilled /> Oratoria, explicación y calidad de video</li> : ""}
                                {video.reason_etapa?.includes("latte_art") ? <li><RxDotFilled /> Latte Art</li> : ""}
                              </ul>
                              {video.reason_description_etapa?.length ? <div className='reason_description'>{video.reason_description_etapa}</div> : ""}
                            </div>
                            }
                             
                          </div>
                        </div>
                        
                    )
                  })}
                  </div>
                : 
                <div className='novideos'>No hay videos para mostrar</div>
                }
            </div>
          </div>
          <div className='actions'>
              <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
                <p>Instructivo</p>
              </div>
              <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
                <p>Reglamento</p>
              </div>
              <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
                <p>Preguntas Frecuentes</p>
              </div>
          </div>
        </div>
        ), [
          bocasAll,
          bocaSelected,
          handleChangeFilter,
          handleFilter,
          videos,
          showModalDisapprove,
          disapproveErrors,
          disapproveReasons,
          handleReasonChange,
          disapproveDescriptions,
          handleDescriptionChange,
          disapproveLoading,
          handleConfirmDisapprove,
          handleCloseDisapproveModal,
          _player,
          handleVideoProgress,
          handleOnReady,
          handleVideoPlay,
          handleVideoStart,
          handleVideoStop,
          handleVideoEnded,
          handleVideoSeek,
          user,
          handleApprove,
          etapaActiva,
          handleClick,
          handleDeleteResult,
          handleDownloadPDF,
        ]);
    
    const Uploader = () => {
        return (
            <div className='box_upload_video_etapa1'>
          <div className='upload_video_text'>{uploadVideoText}</div>
          {uploadVideoText1.length ? <div className='upload_video_text1'>{uploadVideoText1}</div> : ""}
          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          <div className='inner'>

            {!consignaEtapa && videoEtapaUpload === true ?
            <div className='video_block'>
              <div className='bt_condiciones' onClick={() => handleDownloadPDF("condiciones")}>¡Preparate leyendo las condiciones para armar tu video!</div>
            </div> : ""}

            {!videoEtapa ?
            <>
            <div className='box_video_guide_etapa1'>
              <ReactPlayer
                ref={_player}
                className={`react-player`}
                playing={false}
                url={video_consigna_fase_url}
                width='100%'
                height='100%'
                controls={true}
                onProgress={(progress) => { !consignaEtapa && handleVideoProgress(progress, etapaActiva)}}
                onReady={handleOnReady}
                onPlay={handleVideoPlay}
                onStart={handleVideoStart}
                onStop={handleVideoStop}
                onEnded={handleVideoEnded}
                onSeek={handleVideoSeek}
                config={reactPlayerConfig}
              />
            </div> 
            </>
            : ""}


            <div className='box_uploader'>
              
              {videoEtapaUpload === false ? <>El plazo para cargar tu video de la {titleFase} finalizó.</> : ""}

              {(!startUploading && !videoEtapa && videoEtapaUpload) ? 
              <>
              <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
              <div onClick={() => {consignaEtapa && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa ? " disabled" : ""}`}>
                <p>SELECCIONAR VIDEO</p>
              </div>
              </>
              : ""}

              {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

              {videoEtapa ?
                <div className='box_video_loaded1'>
                  <div className='title'>
                    <div className='icon'><SiCoffeescript /></div>
                    <p>Video {titleFase} publicado</p>
                  </div>
                  <div className='date'>{moment(videoEtapa.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>
                  
                  {videoEtapa?.reason_etapa?.length ?
                  <div className='box_rejected'>
                    <div className='title'>Motivos de rechazo:</div>
                    <ul>
                      {videoEtapa.reason_etapa?.includes("emulsion_de_leche") ? <li><RxDotFilled /> <div>Emulsión de la leche</div></li> : ""}
                      {videoEtapa.reason_etapa?.includes("oratoria_y_transmision_al_equipo") ? <li><RxDotFilled /> Oratoria, explicación y calidad de video</li> : ""}
                      {videoEtapa.reason_etapa?.includes("latte_art") ? <li><RxDotFilled /> Latte Art</li> : ""}
                      {/* {videoEtapa.reason_etapa.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                      {videoEtapa.reason_etapa.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                      {videoEtapa.reason_etapa.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""} */}
                    </ul>
                    {videoEtapa.reason_description_etapa?.length ? <div className='reason_description'>{videoEtapa.reason_description_etapa}</div> : ""}
                  </div>
                  :
                  !videoEtapa.approve_etapa ?
                    textDateFase && <div className='text_pending'>{textDateFase}</div> : ""
                  }
                  
                  {videoEtapa?.reason_etapa?.length === 0 && videoEtapa.approve_etapa === false ?
                    <div className='box_rejected'>
                      <>Tu video fue desaprobado</>
                      {videoEtapa.reason_description_etapa?.length ? <div className='reason_description'>{videoEtapa.reason_description_etapa}</div> : ""}
                    </div>
                  : "" }

                  {videoEtapa.approve_etapa ? 
                    <div className='box_approved'>Tu video fue aprobado</div>
                  : "" }

                  <div className='box_video_guide_etapa1'>
                    <ReactPlayer
                      ref={_player}
                      className={`react-player`}
                      playing={false}
                      url={`https://vimeo.com/${videoEtapa.video_id}`}
                      width='100%'
                      height='100%'
                      controls={true}
                      onProgress={(progress) => { !consignaEtapa && handleVideoProgress(progress, etapaActiva)}}
                      onReady={handleOnReady}
                      onPlay={handleVideoPlay}
                      onStart={handleVideoStart}
                      onStop={handleVideoStop}
                      onEnded={handleVideoEnded}
                      onSeek={handleVideoSeek}
                      config={reactPlayerConfig}
                    />
                  </div>
                  <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                </div>
              : "" }

              {(!startUploading && selectedVideo) ?
              <div className='file_data'>
                <div className='name'>
                  <div className='label'>Nombre del archivo:</div>
                  <div className='value'>{fileName}</div>
                </div>
                <div className='size'>
                  <div className='label'>Peso del archivo:</div>
                  <div className='value'>{fileSize}</div>
                </div>
              </div> 
              : ""}

              {(!startUploading && selectedVideo) ?
              <div onClick={() => handleUpload(etapaActiva)} className={`bt_gray bt_upload_file${!selectedVideo ? " disabled" : "" }`}>
                <p>SUBÍ TU VIDEO</p>
              </div>
              : ""}

              {startUploading ?
              <div className='data_progress'>
                <div className='progress_text'>
                  <div className='label'>Progreso de subida:</div>
                  <div className='value'>{uploadProgress}%</div>
                </div>
                {isLoadingVideo ? <div className='loaging'><CircularProgress size={25} /></div> : ""}
                <div className='video_upload_response'>{uploadStatus}</div>
                {/* 
                
                <div className='video_upload_response'>Estado: {uploadUiState} | Cliente: {clientPercent}% | Vimeo: {vimeoPercent}%</div> 
                */}
                {uploadUiState === 'failed' && uploadErrorMessage ? <div className='video_upload_response'>{uploadErrorMessage}</div> : ""}
                {(uploadUiState === 'uploading' || uploadUiState === 'processing') ?
                <div onClick={handleCancelUpload} className='bt_gray bt_upload_file bt_cancel_file'>
                  <p>CANCELAR SUBIDA</p>
                </div>
                : ""}

                
              </div> : ""}

            </div>
          </div>

          

        </div>
        )
        return (
            <div>
                


                <div className='box_upload_video_etapa1'>
                    <div className='upload_video_text'>¡Bienvenidos Expertos a la Copa Barista 2026!</div>

                    <div className='actions'>
                        <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
                        <p>Instructivo</p>
                        </div>
                        <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
                        <p>Reglamento</p>
                        </div>
                        <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
                        <p>Preguntas Frecuentes</p>
                        </div>
                    </div>

                    <div className='inner'>

                        {!conditionsViewedEtapa1 && videoEtapa1Upload === true ?
                        <div className='video_block'>
                        <div className='bt_condiciones' onClick={() => handleDownloadPDF("condiciones")}>¡Preparate leyendo las condiciones para armar tu video!</div>
                        </div> : ""}

                        {!videoEtapa1 ?
                        <>
                        <div className='box_video_guide_etapa1'>
                        <ReactPlayer
                            ref={_player}
                            className={`react-player`}
                            playing={false}
                            url={"https://vimeo.com/1115536829"}
                            width='100%'
                            height='100%'
                            controls={true}
                            onProgress={(progress) => { !consignaEtapa1 && handleVideoProgress(progress, etapaActiva)}}
                            onReady={handleOnReady}
                            onPlay={handleVideoPlay}
                            onStart={handleVideoStart}
                            onStop={handleVideoStop}
                            onEnded={handleVideoEnded}
                            onSeek={handleVideoSeek}
                            config={{ 
                            file: {
                                attributes: {
                                controlsList: 'nodownload'  //<- this is the important bit
                                }
                            },
                            vimeo: {
                                playerOptions: {
                                controls: true,
                                interactive_markers: false,
                                interactive_params: false,
                                vimeo_logo: false,
                                play_button_position: "center",
                                progress_bar: true,
                                title: false,
                                //responsive: true
                                }
                            }
                            }}
                        />
                        </div> 
                        </>
                        : ""}


                        <div className='box_uploader'>


                           
                            
                        {isUploadActive ? (
                            <>
                                <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
                                {/* <div onClick={() => {consignaEtapa1 && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa1 ? " disabled" : ""}`}> */}
                                <div onClick={() => {consignaEtapa && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa ? " disabled" : ""}`}>
                                    <p>SELECCIONAR VIDEO</p>
                                </div>
                            </>
                        ) : (
                            <>El plazo para cargar tu video de la {titleFase} finalizó.</>
                        )}




                        {/* {(!startUploading && !videoEtapa1 && videoEtapa1Upload) ? 
                        <>
                        <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
                        <div onClick={() => {consignaEtapa1 && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa1 ? " disabled" : ""}`}>
                            <p>SELECCIONAR VIDEO</p>
                        </div>
                        </>
                        : ""} */}

                        {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

                        {videoEtapa1 ?
                            <div className='box_video_loaded1'>
                            <div className='title'>Video {titleFase} publicado</div>
                            <div className='date'>{moment(videoEtapa1.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>
                            
                            {videoEtapa1?.reason_etapa1?.length ?
                            <div className='box_rejected'>
                                <div className='title'>Motivos de rechazo:</div>
                                <ul>
                                {videoEtapa1.reason_etapa1.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                                {videoEtapa1.reason_etapa1.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                                {videoEtapa1.reason_etapa1.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                                </ul>
                                {videoEtapa1.reason_description_etapa1?.length ? <div className='reason_description'>{videoEtapa1.reason_description_etapa1}</div> : ""}
                            </div>
                            :
                            !videoEtapa1.arrpove_etapa1 ?
                                <div className='text_pending'>{textDateFase}</div> : ""
                            }

                            {videoEtapa1.arrpove_etapa1 ? 
                                <div className='box_approved'>Tu video fue aprobado</div>
                            : "" }

                            <div className='box_video_guide_etapa1'>
                                <ReactPlayer
                                ref={_player}
                                className={`react-player`}
                                playing={false}
                                url={`https://vimeo.com/${videoEtapa1.video_id}`}
                                width='100%'
                                height='100%'
                                controls={true}
                                onProgress={(progress) => { !consignaEtapa1 && handleVideoProgress(progress, etapaActiva)}}
                                onReady={handleOnReady}
                                onPlay={handleVideoPlay}
                                onStart={handleVideoStart}
                                onStop={handleVideoStop}
                                onEnded={handleVideoEnded}
                                onSeek={handleVideoSeek}
                                config={{ 
                                    file: {
                                    attributes: {
                                        controlsList: 'nodownload'  //<- this is the important bit
                                    }
                                    },
                                    vimeo: {
                                    playerOptions: {
                                        controls: true,
                                        interactive_markers: false,
                                        interactive_params: false,
                                        vimeo_logo: false,
                                        play_button_position: "center",
                                        progress_bar: true,
                                        title: false,
                                        //responsive: true
                                    }
                                    }
                                }}
                                />
                            </div>
                            <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                            </div>
                        : "" }
                        




                        {(!startUploading && selectedVideo) ?
                            <div className='file_data'>
                                <div className='name'>
                                    <div className='label'>Nombre del archivo:</div>
                                    <div className='value'>{fileName}</div>
                                </div>
                                <div className='size'>
                                    <div className='label'>Peso del archivo:</div>
                                    <div className='value'>{fileSize}</div>
                                </div>
                            </div> 
                        : ""}

                        {(!startUploading && selectedVideo) ?
                            <div onClick={() => handleUpload(etapaActiva)} className={`bt_gray bt_upload_file${!selectedVideo ? " disabled" : "" }`}>
                                <p>SUBÍ TU VIDEO</p>
                            </div>
                        : ""}

                        {startUploading ?
                        <div className='data_progress'>
                            <div className='progress_text'>
                                <div className='label'>Progreso de subida:</div>
                                <div className='value'>{uploadProgress}%</div>
                            </div>

                            <div className='video_upload_response'>{uploadStatus}</div>
                            <div className='video_upload_response'>Estado: {uploadUiState} | Cliente: {clientPercent}% | Vimeo: {vimeoPercent}%</div>
                            {uploadUiState === 'failed' && uploadErrorMessage ? <div className='video_upload_response'>{uploadErrorMessage}</div> : ""}
                            {(uploadUiState === 'uploading' || uploadUiState === 'processing') ?
                            <div onClick={handleCancelUpload} className='bt_gray bt_upload_file'>
                              <p>CANCELAR SUBIDA</p>
                            </div>
                            : ""}

                            {isLoadingVideo ? <div className='loaging'><CircularProgress size={25} /></div> : ""}
                        </div> : ""}





                        </div>
                    </div>

                    

                    </div>


            </div>
        );
    };

    const VideoGrid = () => {
        return (
            <div className='box_voting'>
              <div className='inner'>
                
                {/* <div className='intro_text'>¡Conocé a los Baristas que compiten en esta nueva edición!</div> */}
                {/* <div className='intro_text'>¡TE PRESENTAMOS A LOS 50 BARISTAS QUE COMPITEN EN LA FASE 2 POR UN LUGAR EN LA GRAN FINAL!</div> */}
                <div className='intro_text'>¡PRESENTAMOS A LOS 8 BARISTAS QUE YA ESTÁN EN LA FINAL!</div>

                {/* <span className='highlight'>Texto 2</span></div> */}
                {/* <div className='intro_text'>Tu voto es clave para que tu barista favorito avance en la competencia.<br />
                <span className='highlight'>Podés votar hasta el 29 de septiembre inclusive.</span></div> */}
                
                {/* <div className='title'>SHELL</div> */}
                <div className='box_video_list'>
                  
                    {videos === null ? <>cargando</> : ""}
                    {videos !== null && videos?.length ?
                    <div className='video_elements'>
                      {videos.map(video => {
                        return(
                          <div className='video_element'>
                            <div className='video'>
                              <ReactPlayer
                                ref={_player}
                                className={`react-player`}
                                playing={false}
                                url={`https://vimeo.com/${video.video_id}`}
                                width='100%'
                                height='100%'
                                controls={true}
                                onProgress={(progress) => { handleVideoProgress(progress)}}
                                onReady={handleOnReady}
                                onPlay={handleVideoPlay}
                                onStart={handleVideoStart}
                                onStop={handleVideoStop}
                                onEnded={handleVideoEnded}
                                onSeek={handleVideoSeek}
                                config={{ 
                                  file: {
                                    attributes: {
                                      controlsList: 'nodownload'  //<- this is the important bit
                                    }
                                  },
                                  vimeo: {
                                    playerOptions: {
                                      controls: true,
                                      interactive_markers: false,
                                      interactive_params: false,
                                      vimeo_logo: false,
                                      play_button_position: "center",
                                      progress_bar: true,
                                      title: false,
                                      //responsive: true
                                    }
                                  }
                                }}
                              />
                            </div>
                            <div className='box_video_data'>
                              <div className='title'>{video.title}</div>
                              <div className='description'>{video.description}</div>
                            </div>
                            
                          </div>
                        )
                      })}
                      </div>
                    : 
                      <div className='novideos'>No hay videos para mostrar</div>
                    }
                  
                </div>
              </div>
            </div>
        );
    };

    const BaristaSelection = () => {
        return (
            <div className='box_select_barista'>
                <div className='select_barista_text'>
                    ¡Bienvenidos a la inscripción de la Copa Barista 2026!<br/>
                    Le solicitamos que revise el instructivo antes de seleccionar al Experto/a concursante.<br/>
                    Si no puede visualizar al Experto/a, por favor envíe un correo a contacto@somosprotagonistas.com.ar.
                </div> 

                <div className='actions'>
                    <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
                        <p>Instructivo</p>
                    </div>
                    <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
                        <p>Reglamento</p>
                    </div>
                    <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
                        <p>Preguntas Frecuentes</p>
                    </div>
                </div>

                {!closeSelection ?
                    <div className='select_barista_inner'>
                        <div className='title'>Seleccioná una boca</div>
                        <div className='select_boca'>
                            <select onChange={handleBoca}>
                                {bocas?.map(boca => {
                                    return(
                                        <option value={boca.value} selected={boca.value === bocaSelected}>{boca.label}</option>
                                    )
                                })}
                            </select>
                        </div>

                        {haveBarista ? 
                            <div className='barista_selected'>
                                <div className='label'>Barista seleccionado</div>
                                <div className='value'>{`${haveBarista.name} ${haveBarista.last_name}`}</div>
                            </div>
                        :
                            <div className='select_barista'>
                                {expertos?.map(experto => {
                                    return(
                                        <div className='barista_item'>
                                            <div className='name'><p>{`${experto.name} ${experto.last_name}`}</p></div>
                                            <div className='actions'>
                                                <div className={`bt_barista_check${baristaSelected === experto.id ? " selected" : ""}`} onClick={() => handleSetBarista(experto)}>
                                                    {baristaSelected === experto.id ? <div className='icon'><PiCheckFatFill /></div> : ""}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                                {expertos ?
                                    <div onClick={handleSaveBarista} className={`bt_gray bt_save_barista${!selectedVideo ? " disabled" : "" }`}>
                                        <p>Aceptar</p>
                                    </div> 
                                : ""}
                            </div> 
                        }
                    </div> 
                :    
                    <div className='box_voting_pending box_close_selection'>
                        <div className='inner'>
                            <div className='text'>
                                Estimados Empresarios y Gerentes: les informamos que la instancia de inscripción ha finalizado.
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

  if(!user || scope === null || !isOpen || etapaActiva === null){
    return <WrappedStyled>
            <div className='container_loader'>
              <div className='loader'>
                <CircularProgress size={30} />
              </div>
            </div>
          </WrappedStyled>;
}



    return (
        <WrappedStyled>

            {/* <div className='baristas_lineas'>
                <img src='images/baristas_lineas.svg' />
            </div>
            <div className='baristas_lineas_r'>
                <img src='images/baristas_lineas_r.svg' />
            </div> */}

            <SnackbarStyled
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={openSnack}
              onClose={handleSnackClose}
              message={snackMessage}
              key={snackKey}
              autoHideDuration={5000}
              className="success"
            />

            <div className='logo_top'>
                <img src='images/baristas_logo_2026.svg' /> 
            </div>
            
            <InnerStyled>
                {showPresentation ? 
                    
                    
                    <div className='box_welcome'>
                        {/* <div className='welcome_text'>
                            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less letters.
                        </div>  */}
                        <div className='welcome_video'>
                            <ReactPlayer
                                ref={_player}
                                className={`react-player`}
                                playing={false}
                                url={"https://vimeo.com/1229249539"}
                                width='100%'
                                height='100%'
                                controls={true}
                                onProgress={(progress) => { handleVideoProgress(progress)}}
                                onReady={handleOnReady}
                                onPlay={handleVideoPlay}
                                onStart={handleVideoStart}
                                onStop={handleVideoStop}
                                onEnded={handleVideoEnded}
                                onSeek={handleVideoSeek}
                                config={{ 
                                    file: {
                                    attributes: {
                                        controlsList: 'nodownload'  //<- this is the important bit
                                    }
                                    },
                                    vimeo: {
                                    playerOptions: {
                                        volume: true,
                                        interactive_markers: false,
                                        interactive_params: false,
                                        vimeo_logo: false,
                                        play_button_position: "center",
                                        //progress_bar: true,
                                        title: false,
                                        responsive: false
                                    }
                                    }
                                }}
                            />
                        </div>

                        {/* <div className='title_final'>Conocé a los ganadores de la Copa Barista edición 2025</div>  */}
                        
                        {/* {showIngreso && (
                            <div className='actions'>
                                <div className='bt_gray' onClick={handleStart}>
                                    <p>Ingresar</p>
                                </div>
                            </div>
                        )} */}

                        {etapaActiva !== 'countdown' && (
                            <div className='actions'>
                                <div className='bt_gray' onClick={handleStart}>
                                    <p>Ingresar</p>
                                </div>
                            </div>
                        )}
            
                        {etapaActiva === 'countdown' && (
                          <div className='countdown'>
                              <Countdown 
                                  date={final_date} 
                                  onComplete={handleOnCompleteCountDown}
                                  renderer={props => <div className='countdown_inner'>
                                                          <div className='data'>
                                                              <div className='value'>{zeroPad(props.days)}</div>
                                                              <div className='label'>Días</div>
                                                          </div>
                                                          <div className='dots'>:</div>
                                                          <div className='data'>
                                                              <div className='value'>{zeroPad(props.hours)}</div>
                                                              <div className='label'>Horas</div>
                                                          </div>
                                                          <div className='dots'>:</div>
                                                          <div className='data'>
                                                              <div className='value'>{zeroPad(props.minutes)}</div>
                                                              <div className='label'>Min</div>
                                                          </div>
                                                          <div className='dots'>:</div>
                                                          <div className='data'>
                                                              <div className='value'>{zeroPad(props.seconds)}</div>
                                                              <div className='label'>Seg</div>
                                                          </div>
                                                      </div>}
                                                      
                                                      
                              />
                          </div>
                        )}

                    </div>




                : null}
                {!showPresentation ? (
                    <>
                        {whatShow === "admin" && Admin }
                        {whatShow === "uploader" && Uploader() }
                        {whatShow === "videogrid" && <VideoGrid /> }
                        {whatShow === "inscripcion" && <BaristaSelection />}
                    </>
                ) : null}
            </InnerStyled>
        </WrappedStyled>
    )






  return (
    <WrappedStyled>
      
      <MenuStyled
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleDisapprove("etapa1", "especificaciones")}>Especificaciones</MenuItem>
        <MenuItem onClick={() => handleDisapprove("etapa1", "consigna")}>Consigna</MenuItem>
        <MenuItem onClick={() => handleDisapprove("etapa1", "ambas")}>Ambas</MenuItem>
      </MenuStyled>

      <SnackbarStyled
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnack}
        onClose={handleSnackClose}
        message={snackMessage}
        key={snackKey}
        autoHideDuration={5000}
        className="success"
      />

      <div className='baristas_lineas'>
        <img src='images/baristas_lineas.svg' />
      </div>
      <div className='baristas_lineas_r'>
        <img src='images/baristas_lineas_r.svg' />
      </div>

      <div className='logo_top'>
        <img src='images/baristas_logo.svg' /> 
      </div>

      {showPresentation ? 
        <div className='box_welcome'>
          {/* <div className='welcome_text'>
            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less letters.
          </div>  */}
          <div className='welcome_video'>
            <ReactPlayer
              ref={_player}
              className={`react-player`}
              playing={false}
              url={"https://vimeo.com/1115538804"}
              width='100%'
              height='100%'
              controls={true}
              onProgress={(progress) => { handleVideoProgress(progress)}}
              onReady={handleOnReady}
              onPlay={handleVideoPlay}
              onStart={handleVideoStart}
              onStop={handleVideoStop}
              onEnded={handleVideoEnded}
              onSeek={handleVideoSeek}
              config={{ 
                file: {
                  attributes: {
                    controlsList: 'nodownload'  //<- this is the important bit
                  }
                },
                vimeo: {
                  playerOptions: {
                    volume: true,
                    interactive_markers: false,
                    interactive_params: false,
                    vimeo_logo: false,
                    play_button_position: "center",
                    //progress_bar: true,
                    title: false,
                    responsive: true
                  }
                }
              }}
            />
          </div>

          <div className='title_final'>Conocé a los ganadores de la Copa Barista edición 2025</div> 
          
          <div className='actions'>
            <div className='bt_gray' onClick={handleStart}>
              <p>Ingresar</p>
            </div>
          </div>
          
          
          {/* <div className='countdown'>
            <Countdown 
              date={final_date} 
              onComplete={handleOnCompleteCountDown}
              renderer={props => <div className='countdown_inner'>
                                  <div className='data'>
                                    <div className='value'>{zeroPad(props.days)}</div>
                                    <div className='label'>Días</div>
                                  </div>
                                  <div className='dots'>:</div>
                                  <div className='data'>
                                    <div className='value'>{zeroPad(props.hours)}</div>
                                    <div className='label'>Horas</div>
                                  </div>
                                  <div className='dots'>:</div>
                                  <div className='data'>
                                    <div className='value'>{zeroPad(props.minutes)}</div>
                                    <div className='label'>Min</div>
                                  </div>
                                  <div className='dots'>:</div>
                                  <div className='data'>
                                    <div className='value'>{zeroPad(props.seconds)}</div>
                                    <div className='label'>Seg</div>
                                  </div>
                                </div>}
                                    
                                    
            />
          </div> */}

        </div>
      : "" }

      {!showPresentation /*&& (user.role === "experto" || user.role === "empresario")*/ && scope === "etapa333" && !user.is_winner ?
        //user.role !== "shell" ?
        <div className='box_voting'>
          <div className='inner'>
            
            <div className='intro_text'>Texto 1</div>{/* ¡YA ESTAMOS EN LA RECTA FINAL DE LA COPA BARISTA 2024! */}
            <div className='intro_text2'>Texto 2</div>{/* Conocé las 8 prácticas que están en camino a ser las ganadoras. */}

            {/* <div className='intro_text2'>Muy pronto conoceremos las prácticas que están en camino a ser las ganadoras.</div> */}
            <div className='box_video_list'>
            
                {videoSelectedEtapa1 === null ? <>cargando</> : ""}
                {videoSelectedEtapa1 !== null && videoSelectedEtapa1.length ?
                <div className='video_elements'>
                  {videoSelectedEtapa1.map(video => {
                    return(
                      <div className='video_element'>
                        <div className='video'>
                          <ReactPlayer
                            ref={_player}
                            className={`react-player`}
                            playing={false}
                            url={`https://vimeo.com/${video.video_id}`}
                            width='100%'
                            height='100%'
                            controls={true}
                            onProgress={(progress) => { handleVideoProgress(progress)}}
                            onReady={handleOnReady}
                            onPlay={handleVideoPlay}
                            onStart={handleVideoStart}
                            onStop={handleVideoStop}
                            onEnded={handleVideoEnded}
                            onSeek={handleVideoSeek}
                            config={{ 
                              file: {
                                attributes: {
                                  controlsList: 'nodownload'  //<- this is the important bit
                                }
                              },
                              vimeo: {
                                playerOptions: {
                                  controls: true,
                                  interactive_markers: false,
                                  interactive_params: false,
                                  vimeo_logo: false,
                                  play_button_position: "center",
                                  progress_bar: true,
                                  title: false,
                                  //responsive: true
                                }
                              }
                            }}
                          />
                        </div>
                        <div className='box_video_data'>
                          <div className='title'>{video.title}</div>
                          <div className='description'>{video.description}</div>
                        </div>
                      </div>
                    )
                  })}
                  </div>
                : 
                  <div className='novideos'>No hay videos para mostrar</div>
                }
              
            </div>
          </div>
        </div>
      : ""}













      {/* {!showPresentation && user.role === "shell" && (scope === etapaActiva || scope === "vote") ?
      <div className='box_approve_video'>
        <div className='inner'>
          <div className='intro_text'>Una vez aprobado o desaprobado, el video no podrá ser modificado. Por favor, asegúrese de su decisión antes de proceder.</div>

          <div className='filter_videos'>
            <div className='select_bocas'>
              <label>EESS:</label>
              <select onChange={(e) => handleChangeFilter(e, "boca")}>
                <option value="">Seleccionar una opción</option>
                {bocasAll.map(boca => {
                  return(
                    <option value={boca.boca}>{`${boca.boca} - ${boca.razon}`}</option>
                  )
                })}
              </select>
            </div>
            <div className='select_status'>
              <label>Estado:</label>
              <select onChange={(e) => handleChangeFilter(e, "status")}>
                <option value="">Seleccionar una opción</option>
                <option value="approved">Aprobado</option>
                <option value="disapproved">Desaprobado</option>
                <option value="pending">Pendiente</option>
              </select>
            </div>
            <div className='bt_gray bt_filter' onClick={handleFilter}>
              <p>Filtrar</p>
            </div>
          </div>

          <div className='box_video_list'>

              
              
              {videos === null ? <>cargando</> : ""}
              {videos !== null && videos.length ?
              <div className='video_elements'>
                {videos.map(video => {
                  return(
                      
                      
                      <div className='video_element'>
                        
                        {showModalDisapprove.includes(Number(video.id)) ? 
                          <div className='box_disapprove'>
                            {disapproveErrors[video.id] && (
                              <div className='box_disapprove_error'>Para continuar, seleccione un motivo de desaprobación.</div>
                            )}
                            <div className='disapprove_reasons'>
                              <div className='title'>Desaprobación de video</div>
                              <div className='description'>Por favor, seleccione el motivo de la desaprobación del video.</div>
                              <div className='reasons'>
                                <div className='reason'>
                                  <input 
                                    type="checkbox" 
                                    id={`reason1_${video.id}`} 
                                    name={`reason_${video.id}`} 
                                    value="espresso_perfecto"
                                    checked={disapproveReasons[video.id]?.espresso_perfecto || false}
                                    onChange={(e) => handleReasonChange(video.id, 'espresso_perfecto', e.target.checked)}
                                  />
                                  <label htmlFor={`reason1_${video.id}`}>Espresso perfecto</label>
                                </div>
                                <div className='reason'>
                                  <input 
                                    type="checkbox" 
                                    id={`reason2_${video.id}`} 
                                    name={`reason_${video.id}`} 
                                    value="presentacion_personal"
                                    checked={disapproveReasons[video.id]?.presentacion_personal || false}
                                    onChange={(e) => handleReasonChange(video.id, 'presentacion_personal', e.target.checked)}
                                  />
                                  <label htmlFor={`reason2_${video.id}`}>Presentación personal</label>
                                </div>
                                <div className='reason'>
                                  <input 
                                    type="checkbox" 
                                    id={`reason3_${video.id}`} 
                                    name={`reason_${video.id}`} 
                                    value="especificaciones_tecnicas"
                                    checked={disapproveReasons[video.id]?.especificaciones_tecnicas || false}
                                    onChange={(e) => handleReasonChange(video.id, 'especificaciones_tecnicas', e.target.checked)}
                                  />
                                  <label htmlFor={`reason3_${video.id}`}>Especificaciones técnicas</label>
                                </div>
                              </div>
                              <div className='reason_description'>
                                <label>Descripción:</label>
                                <textarea
                                  value={disapproveDescriptions[video.id] || ''}
                                  onChange={(e) => handleDescriptionChange(video.id, e.target.value)}
                                  placeholder="Ingrese una descripción detallada..."
                                />
                              </div>
                            </div>
                            
                            {disapproveLoading[video.id] ? (
                              <div className='loader'>
                                <CircularProgress size={30} />
                                <span>Procesando...</span>
                              </div>
                            ) : (
                              <div className='actions'>
                                <div className='bt_gray bt_confirm' onClick={() => handleConfirmDisapprove(video.id)}>
                                  <p>Confirmar</p>
                                </div>
                                <div className='bt_gray bt_cancel' onClick={() => setShowModalDisapprove(showModalDisapprove.filter(id => id !== video.id))}>
                                  <p>Cancelar</p>
                                </div>
                              </div>
                            )}
    
                          </div> 
                        : ""}

                        <div className='video'>
                          <ReactPlayer
                            ref={_player}
                            className={`react-player`}
                            playing={false}
                            url={`https://vimeo.com/${video.video_id}`}
                            width='100%'
                            height='100%'
                            controls={true}
                            onProgress={(progress) => { handleVideoProgress(progress)}}
                            onReady={handleOnReady}
                            onPlay={handleVideoPlay}
                            onStart={handleVideoStart}
                            onStop={handleVideoStop}
                            onEnded={handleVideoEnded}
                            onSeek={handleVideoSeek}
                            config={{ 
                              file: {
                                attributes: {
                                  controlsList: 'nodownload'  //<- this is the important bit
                                }
                              },
                              vimeo: {
                                playerOptions: {
                                  interactive_markers: false,
                                  interactive_params: false,
                                  vimeo_logo: false,
                                  play_button_position: "center",
                                  progress_bar: true,
                                  title: false,
                                  //responsive: true
                                }
                              }
                            }}
                          />
                        </div>
                        <div className='data'>
                          <div className='title'>{video.title}</div>
                          <div className='description'>{video.description}</div>

                          {!video.arrpove_etapa1 && !video?.reason_etapa1?.length ? 
                          <div className='actions'>
                              
                              <div className='bt_gray bt_approve' onClick={() => handleApprove(video.id, "etapa1")}>
                                <p>APROBAR</p>
                              </div>
                              
                              <div className='bt_gray bt_disapprove' id="basic-button" onClick={(e) => handleClick(e, video.id)}>
                                <p>DESAPROBAR</p>
                              </div>
        
                          </div>
                          :
                          video.arrpove_etapa1 ? 
                          <div className='box_shell_approve'>
                            <div className='bt_delete_result' onClick={() => handleDeleteResult(video.id)}><MdOutlineClose /></div>
                            Aprobado
                          </div>
                          :
                          <div className='box_shell_disapprove'>
                            <div className='bt_delete_result' onClick={() => handleDeleteResult(video.id)}><MdOutlineClose /></div>
                            <ul>
                              {video.reason_etapa1.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                              {video.reason_etapa1.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                              {video.reason_etapa1.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                            </ul>
                            {video.reason_description_etapa1?.length ? <div className='reason_description'>{video.reason_description_etapa1}</div> : ""}
                          </div>
                          }
                          
                        </div>
                      </div>
                      
                  )
                })}
                </div>
              : 
               <div className='novideos'>No hay videos para mostrar</div>
              }
          </div>
        </div>
        <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
        </div>
      </div>
      :
      ""} */}








      {/* {!showPresentation && user.role === "empresario" && scope !== "vote" ?
      <div className='box_select_barista'>
        <div className='select_barista_text'>
        ¡Bienvenidos a la inscripción de la  segunda Edición Copa Barista 2025!<br/>
        Le solicitamos que revise el instructivo antes de seleccionar al Experto/a concursante.<br/>
        Si no puede visualizar al Experto/a, por favor envíe un correo a contacto@somosprotagonistas.com.ar.
        </div> 
        
        <div className='actions'>
          <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
            <p>Instructivo</p>
          </div>
          <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
            <p>Reglamento</p>
          </div>
          <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
            <p>Preguntas Frecuentes</p>
          </div>
        </div>

        {!closeSelection ?
        <div className='select_barista_inner'>
          <div className='title'>Seleccioná una boca</div>
          <div className='select_boca'>
            <select onChange={handleBoca}>
              {bocas?.map(boca => {
                return(
                  <option value={boca.value}>{boca.label}</option>
                )
              })}
              
            </select>
          </div>
          {haveBarista ? 
          <div className='barista_selected'>
            <div className='label'>Barista seleccionado</div>
            <div className='value'>{`${haveBarista.name} ${haveBarista.last_name}`}</div>
          </div>
          :
          <div className='select_barista'>
            {expertos?.map(experto => {
              return(
                <div className='barista_item'>
                  <div className='name'><p>{`${experto.name} ${experto.last_name}`}</p></div>
                  <div className='actions'>
                    <div className={`bt_barista_check${baristaSelected === experto.id ? " selected" : ""}`} onClick={() => handleSetBarista(experto)}>
                      {baristaSelected === experto.id ? <div className=''><IoCheckmarkDoneSharp /></div> : ""}
                    </div>
                  </div>
                </div>
              )
            })}
            {expertos ?
            <div onClick={handleSaveBarista} className={`bt_gray bt_save_barista${!selectedVideo ? " disabled" : "" }`}>
              <p>Aceptar</p>
            </div> : ""}
          </div> 
          }
        </div> 
        : 
        <div className='box_voting_pending box_close_selection'>
          <div className='inner'>
            <div className='text'>
              Estimados Empresarios y Gerentes: les informamos que la instancia de inscripción ha finalizado.
            </div>
          </div>
        </div>
        }

      </div>
      : ""} */}











      {!showPresentation /*&& user.role === "experto" && scope !== "vote"*/ && scope === "etapa3333" ?
        user.is_winner ?
        <div className='box_upload_video_etapa1'>
          
          <div className='upload_video_text'>¡BIENVENIDOS BARISTAS A LA FASE FINAL DE LA COMPETENCIA!</div>

          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          <div className='inner'>

            <div className='ficha'>Subí tu video y envía la receta de tu creación por mail a contacto@somosprotagonistas.com.ar para completar tu participación en esta fase final.</div>

            {!conditionsViewedEtapa3 && videoEtapa3Upload === true ?
            <div className='video_block2'>
              
              <div className='bt_condiciones' onClick={() => handleDownloadPDF("etapa3")}>¡Preparate leyendo las condiciones para armar tu tercer video!</div>
            </div> : ""}


            <div className='box_uploader'>
              
            {videoEtapa3Upload === false ? <>La etapa de participación ha finalizado</> : ""}

              {(!startUploading && !videoEtapa3 && videoEtapa3Upload) ? 
              <>
              <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
              <div onClick={() => {conditionsViewedEtapa3 && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!conditionsViewedEtapa3 ? " disabled" : ""}`}>
                <p>SELECCIONAR VIDEO</p>
              </div>
              </>
              : ""}

              {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

              {videoEtapa3 ?
                <div className='box_video_loaded1'>
                  <div className='title'>Video Fase 3 publicado</div>
                  <div className='date'>{moment(videoEtapa3.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>

                  {videoEtapa3?.reason_etapa3?.length ?
                  <div className='box_rejected'>
                    {!videoEtapa3.arrpove_etapa3 && videoEtapa3.reason_etapa3 === "especificaciones" ? "No cumple con las especificaciones técnicas." : ""}
                    {!videoEtapa3.arrpove_etapa3 && videoEtapa3.reason_etapa3 === "consigna" ? "No cumple con la consigna." : ""}
                    {!videoEtapa3.arrpove_etapa3 && videoEtapa3.reason_etapa3 === "ambas" ? "No cumple con las especificaciones técnicas ni con la consigna indicada." : ""}
                  </div>
                  : "" }

                  {videoEtapa3.arrpove_etapa3 ? 
                    <div className='box_approved'>Tu video fue aprobado</div>
                  : "" }

                  <div className='box_video_guide_etapa1'>
                    <ReactPlayer
                      ref={_player}
                      className={`react-player`}
                      playing={false}
                      url={`https://vimeo.com/${videoEtapa3.video_id}`}
                      width='100%'
                      height='100%'
                      controls={true}
                      onProgress={(progress) => { !consignaEtapa3 && handleVideoProgress(progress, "etapa3")}}
                      onReady={handleOnReady}
                      onPlay={handleVideoPlay}
                      onStart={handleVideoStart}
                      onStop={handleVideoStop}
                      onEnded={handleVideoEnded}
                      onSeek={handleVideoSeek}
                      config={{ 
                        file: {
                          attributes: {
                            controlsList: 'nodownload'  //<- this is the important bit
                          }
                        },
                        vimeo: {
                          playerOptions: {
                            controls: true,
                            interactive_markers: false,
                            interactive_params: false,
                            vimeo_logo: false,
                            play_button_position: "center",
                            progress_bar: true,
                            title: false,
                            //responsive: true
                          }
                        }
                      }}
                    />
                  </div>
                  <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                </div>
              : "" }

              {(!startUploading && selectedVideo) ?
              <div className='file_data'>
                <div className='name'>
                  <div className='label'>Nombre del archivo:</div>
                  <div className='value'>{fileName}</div>
                </div>
                <div className='size'>
                  <div className='label'>Peso del archivo:</div>
                  <div className='value'>{fileSize}</div>
                </div>
              </div> 
              : ""}

              {(!startUploading && selectedVideo) ?
              <div onClick={() => handleUpload("etapa3")} className={`bt_gray bt_upload_file${!selectedVideo ? " disabled" : "" }`}>
                <p>SUBÍ TU VIDEO</p>
              </div>
              : ""}

              {startUploading ?
              <div className='data_progress'>
                <div className='progress_text'>
                  <div className='label'>Progreso de subida:</div>
                  <div className='value'>{uploadProgress}%</div>
                </div>
                
                <div className='video_upload_response'>{uploadStatus}</div>
                <div className='video_upload_response'>Estado: {uploadUiState} | Cliente: {clientPercent}% | Vimeo: {vimeoPercent}%</div>
                {uploadUiState === 'failed' && uploadErrorMessage ? <div className='video_upload_response'>{uploadErrorMessage}</div> : ""}
                {(uploadUiState === 'uploading' || uploadUiState === 'processing') ?
                <div onClick={handleCancelUpload} className='bt_gray bt_upload_file'>
                  <p>CANCELAR SUBIDA</p>
                </div>
                : ""}

                {isLoadingVideo ? <div className='loaging'><CircularProgress size={25} /></div> : ""}
              </div> : ""}

            </div>
          </div>

          

        </div>
        : "" : ""} 












      {/*  INI BLOQUE TEMPORAL PARA MOSTRAR LA PAGINA INTERIOR DE BARISTAS MIENTRAS ESTA ACTIVA LA VOTACION */}
      {/* {!showPresentation && user.role === "experto" && scope === "vote" && user.is_barista ?
        
        <div className='box_upload_video_etapa1'>
          <div className='upload_video_text'>¡Bienvenidos Expertos a la Copa Barista 2025!</div>

          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          <div className='inner'>

            {!conditionsViewedEtapa1 && videoEtapa1Upload === true ?
            <div className='video_block'>
              <div className='bt_condiciones' onClick={() => handleDownloadPDF("condiciones")}>¡Preparate leyendo las condiciones para armar tu video!</div>
            </div> : ""}

            {!videoEtapa1 ?
            <>
            <div className='box_video_guide_etapa1'>
              <ReactPlayer
                ref={_player}
                className={`react-player`}
                playing={false}
                url={"https://vimeo.com/1115536829"}
                width='100%'
                height='100%'
                controls={true}
                onProgress={(progress) => { !consignaEtapa1 && handleVideoProgress(progress, "etapa1")}}
                onReady={handleOnReady}
                onPlay={handleVideoPlay}
                onStart={handleVideoStart}
                onStop={handleVideoStop}
                onEnded={handleVideoEnded}
                onSeek={handleVideoSeek}
                config={{ 
                  file: {
                    attributes: {
                      controlsList: 'nodownload'  //<- this is the important bit
                    }
                  },
                  vimeo: {
                    playerOptions: {
                      controls: true,
                      interactive_markers: false,
                      interactive_params: false,
                      vimeo_logo: false,
                      play_button_position: "center",
                      progress_bar: true,
                      title: false,
                      //responsive: true
                    }
                  }
                }}
              />
            </div> 
            </>
            : ""}


            <div className='box_uploader'>
              
              {videoEtapa1Upload === false ? <>El plazo para cargar tu video de la {titleFase} finalizó.</> : ""}

              {(!startUploading && !videoEtapa1 && videoEtapa1Upload) ? 
              <>
              <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
              <div onClick={() => {consignaEtapa1 && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa1 ? " disabled" : ""}`}>
                <p>SELECCIONAR VIDEO</p>
              </div>
              </>
              : ""}

              {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

              {videoEtapa1 ?
                <div className='box_video_loaded1'>
                  <div className='title'>Video {titleFase} publicado</div>
                  <div className='date'>{moment(videoEtapa1.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>
                  
                  {videoEtapa1?.reason_etapa1?.length ?
                  <div className='box_rejected'>
                    <div className='title'>Motivos de rechazo:</div>
                    <ul>
                      {videoEtapa1.reason_etapa1.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                      {videoEtapa1.reason_etapa1.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                      {videoEtapa1.reason_etapa1.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                    </ul>
                    {videoEtapa1.reason_description_etapa1?.length ? <div className='reason_description'>{videoEtapa1.reason_description_etapa1}</div> : ""}
                  </div>
                  :
                  !videoEtapa1.arrpove_etapa1 ?
                    <div className='text_pending'>{textDateFase}</div> : ""
                  }

                  {videoEtapa1.arrpove_etapa1 ? 
                    <div className='box_approved'>Tu video fue aprobado</div>
                  : "" }

                  <div className='box_video_guide_etapa1'>
                    <ReactPlayer
                      ref={_player}
                      className={`react-player`}
                      playing={false}
                      url={`https://vimeo.com/${videoEtapa1.video_id}`}
                      width='100%'
                      height='100%'
                      controls={true}
                      onProgress={(progress) => { !consignaEtapa1 && handleVideoProgress(progress, "etapa1")}}
                      onReady={handleOnReady}
                      onPlay={handleVideoPlay}
                      onStart={handleVideoStart}
                      onStop={handleVideoStop}
                      onEnded={handleVideoEnded}
                      onSeek={handleVideoSeek}
                      config={{ 
                        file: {
                          attributes: {
                            controlsList: 'nodownload'  //<- this is the important bit
                          }
                        },
                        vimeo: {
                          playerOptions: {
                            controls: true,
                            interactive_markers: false,
                            interactive_params: false,
                            vimeo_logo: false,
                            play_button_position: "center",
                            progress_bar: true,
                            title: false,
                            //responsive: true
                          }
                        }
                      }}
                    />
                  </div>
                  <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                </div>
              : "" }

            </div>
          </div>

          

        </div>
      : ""} */}
      {/*  END BLOQUE TEMPORAL PARA MOSTRAR LA PAGINA INTERIOR DE BARISTAS MIENTRAS ESTA ACTIVA LA VOTACION */}


      









      {/* INI BLOQUE VOTAR */}
      {!showPresentation && whatShow === "vote" ? 
      <div className='box_voting'>
        <div className='inner'>
          <div className='intro_text'>¡La votación finalizó!<br />
          <span className='highlight'>El 6 de octubre vas a conocer quiénes son los baristas que siguen en carrera hacia la próxima etapa.</span></div>
          {/* <div className='intro_text'>Tu voto es clave para que tu barista favorito avance en la competencia.<br />
          <span className='highlight'>Podés votar hasta el 29 de septiembre inclusive.</span></div> */}
          {/* ¡CONOCÉ A LOS 30 BARISTAS QUE PASAN A LA SEGUNDA FASE DE LA COMPETICIÓN! */}
          {/* <div className='title'>SHELL</div> */}
          <div className='box_video_list'>
            
              {videos === null ? <>cargando</> : ""}
              {videos !== null && videos?.length ?
              <div className='video_elements'>
                {videos.map(video => {
                  return(
                    <div className='video_element'>
                      <div className='video'>
                        <ReactPlayer
                          ref={_player}
                          className={`react-player`}
                          playing={false}
                          url={`https://vimeo.com/${video.video_id}`}
                          width='100%'
                          height='100%'
                          controls={true}
                          onProgress={(progress) => { handleVideoProgress(progress)}}
                          onReady={handleOnReady}
                          onPlay={handleVideoPlay}
                          onStart={handleVideoStart}
                          onStop={handleVideoStop}
                          onEnded={handleVideoEnded}
                          onSeek={handleVideoSeek}
                          config={{ 
                            file: {
                              attributes: {
                                controlsList: 'nodownload'  //<- this is the important bit
                              }
                            },
                            vimeo: {
                              playerOptions: {
                                controls: true,
                                interactive_markers: false,
                                interactive_params: false,
                                vimeo_logo: false,
                                play_button_position: "center",
                                progress_bar: true,
                                title: false,
                                //responsive: true
                              }
                            }
                          }}
                        />
                      </div>
                      <div className='box_video_data'>
                        <div className='title'>{video.title}</div>
                        <div className='description'>{video.description}</div>
                      </div>
                      
                      <div className='data'>
                        <div className='votes_counter'>
                          <div className='label'>Votos</div>
                          <div className='value'>{getVotos(video.id)}</div>
                        </div>
                        {(ownVote === video.id) ?
                          <div className='vote_check'>
                            <IoCheckmarkDoneSharp />
                          </div>
                        :
                          <div className='actions'>
                            {isVoting ?
                              whatVoting === video.id ?
                              <div className='loading'><CircularProgress size={30} /></div>
                              : ""
                            :
                              ""
                              // <div className='bt_gray bt_approve' onClick={() => !isVoting && handleVote(video.id, etapaActiva, user.dni)}>
                              //   <p>VOTAR</p>
                              // </div> 
                            }
                          </div>
                        }
                        
                        {/* !user.is_barista &&
                        <div className='actions'>
                          {handleCanVote(canVote, videoEtapa1, video.id) ?
                          <>
                            {isVoting ?
                              whatVoting === video.id ?
                              <div className='loading'><CircularProgress size={30} /></div>
                              : ""
                            :
                              <div className='bt_gray bt_approve' onClick={() => !isVoting && handleVote(video.id, etapaActiva, user.dni)}>
                                <p>VOTAR</p>
                              </div> 
                            }
                          </>
                          : "" }
                        </div>} */}
                        


                       
                      </div>
                      
                    </div>
                  )
                })}
                </div>
              : 
                <div className='novideos'>No hay videos para mostrar</div>
              }
            
          </div>
        </div>
        {/*
        <div className='actions'>
          <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
            <p>Instructivo</p>
          </div>
          <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
            <p>Reglamento</p>
          </div>
          <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
            <p>Preguntas Frecuentes</p>
          </div>
        </div>
        */}
      </div> : ""}

      {/* END BLOQUE VOTAR */}









      {/* INI BLOQUE ADMIN VIDEOs */}
      {!showPresentation && whatShow === 'empresario' ? 
        <div className='box_select_barista'>
          <div className='select_barista_text'>
          ¡Bienvenidos a la inscripción de la  segunda Edición Copa Barista 2025!<br/>
          Le solicitamos que revise el instructivo antes de seleccionar al Experto/a concursante.<br/>
          Si no puede visualizar al Experto/a, por favor envíe un correo a contacto@somosprotagonistas.com.ar.
          </div> 
          
          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          {!closeSelection ?
          <div className='select_barista_inner'>
            <div className='title'>Seleccioná una boca</div>
            <div className='select_boca'>
              <select onChange={handleBoca}>
                {bocas?.map(boca => {
                  return(
                    <option value={boca.value}>{boca.label}</option>
                  )
                })}
                
              </select>
            </div>
            {haveBarista ? 
            <div className='barista_selected'>
              <div className='label'>Barista seleccionado</div>
              <div className='value'>{`${haveBarista.name} ${haveBarista.last_name}`}</div>
            </div>
            :
            <div className='select_barista'>
              {expertos?.map(experto => {
                return(
                  <div className='barista_item'>
                    <div className='name'><p>{`${experto.name} ${experto.last_name}`}</p></div>
                    <div className='actions'>
                      <div className={`bt_barista_check${baristaSelected === experto.id ? " selected" : ""}`} onClick={() => handleSetBarista(experto)}>
                        {baristaSelected === experto.id ? <div className=''><IoCheckmarkDoneSharp /></div> : ""}
                      </div>
                    </div>
                  </div>
                )
              })}
              {expertos ?
              <div onClick={handleSaveBarista} className={`bt_gray bt_save_barista${!selectedVideo ? " disabled" : "" }`}>
                <p>Aceptar</p>
              </div> : ""}
            </div> 
            }
          </div> 
          : 
          <div className='box_voting_pending box_close_selection'>
            <div className='inner'>
              <div className='text'>
                Estimados Empresarios y Gerentes: les informamos que la instancia de inscripción ha finalizado.
              </div>
            </div>
          </div>
          }

        </div>
      : ""}
      {/* END BLOQUE ADMIN VIDEOs */}









      {/* INI BLOQUE ADMIN VIDEOs */}

      {!showPresentation && whatShow === 'admin' ? 

        <div className='box_approve_video'>
          <div className='inner'>
            <div className='intro_text'>Una vez aprobado o desaprobado, el video no podrá ser modificado. Por favor, asegúrese de su decisión antes de proceder.</div>

            <div className='filter_videos'>
              <div className='select_bocas'>
                <label>EESS:</label>
                <select onChange={(e) => handleChangeFilter(e, "boca")}>
                  <option value="">Seleccionar una opción</option>
                  {bocasAll.map(boca => {
                    return(
                      <option value={boca.boca}>{`${boca.boca} - ${boca.razon}`}</option>
                    )
                  })}
                </select>
              </div>
              <div className='select_status'>
                <label>Estado:</label>
                <select onChange={(e) => handleChangeFilter(e, "status")}>
                  <option value="">Seleccionar una opción</option>
                  <option value="approved">Aprobado</option>
                  <option value="disapproved">Desaprobado</option>
                  <option value="pending">Pendiente</option>
                </select>
              </div>
              <div className='bt_gray bt_filter' onClick={handleFilter}>
                <p>Filtrar</p>
              </div>
            </div>

            <div className='box_video_list'>

                
                
                {videos === null ? <>cargando</> : ""}
                {videos !== null && videos.length ?
                <div className='video_elements'>
                  {videos.map(video => {
                    return(
                        
                        
                        <div className='video_element'>
                          
                          {showModalDisapprove.includes(Number(video.id)) ? 
                            <div className='box_disapprove'>
                              {disapproveErrors[video.id] && (
                                <div className='box_disapprove_error'>Para continuar, seleccione un motivo de desaprobación.</div>
                              )}
                              <div className='disapprove_reasons'>
                                <div className='title'>Desaprobación de video</div>
                                <div className='description'>Por favor, seleccione el motivo de la desaprobación del video.</div>
                                {/*<div className='reasons'>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason1_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="espresso_perfecto"
                                      checked={disapproveReasons[video.id]?.espresso_perfecto || false}
                                      onChange={(e) => handleReasonChange(video.id, 'espresso_perfecto', e.target.checked)}
                                    />
                                    <label htmlFor={`reason1_${video.id}`}>Espresso perfecto</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason2_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="presentacion_personal"
                                      checked={disapproveReasons[video.id]?.presentacion_personal || false}
                                      onChange={(e) => handleReasonChange(video.id, 'presentacion_personal', e.target.checked)}
                                    />
                                    <label htmlFor={`reason2_${video.id}`}>Presentación personal</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason3_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="especificaciones_tecnicas"
                                      checked={disapproveReasons[video.id]?.especificaciones_tecnicas || false}
                                      onChange={(e) => handleReasonChange(video.id, 'especificaciones_tecnicas', e.target.checked)}
                                    />
                                    <label htmlFor={`reason3_${video.id}`}>Especificaciones técnicas</label>
                                  </div>
                                </div>*/}
                                <div className='reasons'>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason1_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="emulsion_de_leche"
                                      checked={disapproveReasons[video.id]?.emulsion_de_leche || false}
                                      onChange={(e) => handleReasonChange(video.id, 'emulsion_de_leche', e.target.checked)}
                                    />
                                    <label htmlFor={`reason1_${video.id}`}>Emulsión de la leche</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason2_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="oratoria_y_transmision_al_equipo"
                                      checked={disapproveReasons[video.id]?.oratoria_y_transmision_al_equipo || false}
                                      onChange={(e) => handleReasonChange(video.id, 'oratoria_y_transmision_al_equipo', e.target.checked)}
                                    />
                                    <label htmlFor={`reason2_${video.id}`}>Oratoria, explicación y calidad de video</label>
                                  </div>
                                  <div className='reason'>
                                    <input 
                                      type="checkbox" 
                                      id={`reason3_${video.id}`} 
                                      name={`reason_${video.id}`} 
                                      value="latte_art"
                                      checked={disapproveReasons[video.id]?.latte_art || false}
                                      onChange={(e) => handleReasonChange(video.id, 'latte_art', e.target.checked)}
                                    />
                                    <label htmlFor={`reason3_${video.id}`}>Latte Art</label>
                                  </div>
                                </div>
                                <div className='reason_description'>
                                  <label>Descripción:</label>
                                  <textarea
                                    value={disapproveDescriptions[video.id] || ''}
                                    onChange={(e) => handleDescriptionChange(video.id, e.target.value)}
                                    placeholder="Ingrese una descripción detallada..."
                                  />
                                </div>
                              </div>
                              
                              {disapproveLoading[video.id] ? (
                                <div className='loader'>
                                  <CircularProgress size={30} />
                                  <span>Procesando...</span>
                                </div>
                              ) : (
                                <div className='actions'>
                                  <div className='bt_gray bt_confirm' onClick={() => handleConfirmDisapprove(video.id)}>
                                    <p>Confirmar</p>
                                  </div>
                                  <div className='bt_gray bt_cancel' onClick={() => setShowModalDisapprove(showModalDisapprove.filter(id => id !== video.id))}>
                                    <p>Cancelar</p>
                                  </div>
                                </div>
                              )}
      
                            </div> 
                          : ""}

                          <div className='video'>
                          
                            <ReactPlayer
                              ref={_player}
                              className={`react-player`}
                              playing={false}
                              url={`https://vimeo.com/${video.video_id}`}
                              width='100%'
                              height='100%'
                              controls={true}
                              onProgress={(progress) => { handleVideoProgress(progress)}}
                              onReady={handleOnReady}
                              onPlay={handleVideoPlay}
                              onStart={handleVideoStart}
                              onStop={handleVideoStop}
                              onEnded={handleVideoEnded}
                              onSeek={handleVideoSeek}
                              config={{ 
                                file: {
                                  attributes: {
                                    controlsList: 'nodownload'  //<- this is the important bit
                                  }
                                },
                                vimeo: {
                                  playerOptions: {
                                    interactive_markers: false,
                                    interactive_params: false,
                                    vimeo_logo: false,
                                    play_button_position: "center",
                                    progress_bar: true,
                                    title: false,
                                    //responsive: true
                                  }
                                }
                              }}
                            />
                          
                          </div>
                          <div className='data'>
                            <div className='title'>{video.title}</div>
                            <div className='description'>{video.description}</div>

                            {!video.arrpove_etapa2 && !video?.reason_etapa2?.length ? 
                            <div className='actions'>
                                
                                <div className='bt_gray bt_approve' onClick={() => handleApprove(video.id, 'etapa2')}>
                                  <p>APROBAR</p>
                                </div>
                                
                                <div className='bt_gray bt_disapprove' id="basic-button" onClick={(e) => handleClick(e, video.id)}>
                                  <p>DESAPROBAR</p>
                                </div>
          
                            </div>
                            :
                            video.arrpove_etapa2 ? 
                            <div className='box_shell_approve'>
                              <div className='bt_delete_result' onClick={() => handleDeleteResult(video.id)}><MdOutlineClose /></div>
                              Aprobado
                            </div>
                            :
                            <div className='box_shell_disapprove'>
                              <div className='bt_delete_result' onClick={() => handleDeleteResult(video.id)}><MdOutlineClose /></div>
                              {/* <ul>
                                {video.reason_etapa2.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                                {video.reason_etapa2.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                                {video.reason_etapa2.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                              </ul> */}
                              <ul>
                                {video.reason_etapa2?.includes("emulsion_de_leche") ? <li><RxDotFilled /> <div>Emulsión de la leche</div></li> : ""}
                                {video.reason_etapa2?.includes("oratoria_y_transmision_al_equipo") ? <li><RxDotFilled /> Oratoria, explicación y calidad de video</li> : ""}
                                {video.reason_etapa2?.includes("latte_art") ? <li><RxDotFilled /> Latte Art</li> : ""}
                              </ul>
                              {video.reason_description_etapa2?.length ? <div className='reason_description'>{video.reason_description_etapa2}</div> : ""}
                            </div>
                            }
                             
                          </div>
                        </div>
                        
                    )
                  })}
                  </div>
                : 
                <div className='novideos'>No hay videos para mostrar</div>
                }
            </div>
          </div>
          <div className='actions'>
              <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
                <p>Instructivo</p>
              </div>
              <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
                <p>Reglamento</p>
              </div>
              <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
                <p>Preguntas Frecuentes</p>
              </div>
          </div>
        </div>
      
      : ""}

      {/* END BLOQUE ADMIN VIDEOs */}

                      









      {/* INI BLOQUE GRID VIDEOs */}

      {!showPresentation && whatShow === 'videogrid' ? 

      <div className='box_voting'>
          <div className='inner'>
            
            <div className='intro_text'>¡Conocé a los baristas que siguen demostrando su talento en la competencia!</div>
            {/* <div className='intro_text'>Conocé los videos de la Fase 2 que el Jurado Barista evaluará para definir quiénes avanzan en la competencia.</div> */}
            {/* <div className='intro_text'>¡CONOCÉ A LOS 30 BARISTAS QUE PASAN A LA SEGUNDA FASE DE LA COMPETICIÓN!<br />
            <span className='highlight'>Texto 2</span></div> */}
            {/* <div className='intro_text'>Tu voto es clave para que tu barista favorito avance en la competencia.<br />
            <span className='highlight'>Podés votar hasta el 29 de septiembre inclusive.</span></div> */}
            
            {/* <div className='title'>SHELL</div> */}
            <div className='box_video_list'>
              
                {videos === null ? <>cargando</> : ""}
                {videos !== null && videos?.length ?
                <div className='video_elements'>
                  {videos.map(video => {
                    return(
                      <div className='video_element'>
                        <div className='video'>
                          <ReactPlayer
                            ref={_player}
                            className={`react-player`}
                            playing={false}
                            url={`https://vimeo.com/${video.video_id}`}
                            width='100%'
                            height='100%'
                            controls={true}
                            onProgress={(progress) => { handleVideoProgress(progress)}}
                            onReady={handleOnReady}
                            onPlay={handleVideoPlay}
                            onStart={handleVideoStart}
                            onStop={handleVideoStop}
                            onEnded={handleVideoEnded}
                            onSeek={handleVideoSeek}
                            config={{ 
                              file: {
                                attributes: {
                                  controlsList: 'nodownload'  //<- this is the important bit
                                }
                              },
                              vimeo: {
                                playerOptions: {
                                  controls: true,
                                  interactive_markers: false,
                                  interactive_params: false,
                                  vimeo_logo: false,
                                  play_button_position: "center",
                                  progress_bar: true,
                                  title: false,
                                  //responsive: true
                                }
                              }
                            }}
                          />
                        </div>
                        <div className='box_video_data'>
                          <div className='title'>{video.title}</div>
                          <div className='description'>{video.description}</div>
                        </div>
                        
                      </div>
                    )
                  })}
                  </div>
                : 
                  <div className='novideos'>No hay videos para mostrar</div>
                }
              
            </div>
          </div>
        </div>

      : ""}
      
      {/* END BLOQUE GRID VIDEOs */}











      {/* INI BLOQUE CARGA VIDEO ETAPA 1*/}

      {/* {!showPresentation && whatShow === 'uploader' ?
      
        <div className='box_upload_video_etapa1'>
          <div className='upload_video_text'>{upload_video_text}</div>
          {upload_video_text1.length ? <div className='upload_video_text1'>{upload_video_text1}</div> : ""}
          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          <div className='inner'>

            {!conditionsViewedEtapa && videoEtapaUpload === true ?
            <div className='video_block'>
              <div className='bt_condiciones' onClick={() => handleDownloadPDF("condiciones")}>¡Preparate leyendo las condiciones para armar tu video!</div>
            </div> : ""}

            {!videoEtapa ?
            <>
            <div className='box_video_guide_etapa1'>
              <ReactPlayer
                ref={_player}
                className={`react-player`}
                playing={false}
                url={video_consigna_fase_url}
                width='100%'
                height='100%'
                controls={true}
                onProgress={(progress) => { !consignaEtapa && handleVideoProgress(progress, etapaActiva)}}
                onReady={handleOnReady}
                onPlay={handleVideoPlay}
                onStart={handleVideoStart}
                onStop={handleVideoStop}
                onEnded={handleVideoEnded}
                onSeek={handleVideoSeek}
                config={{ 
                  file: {
                    attributes: {
                      controlsList: 'nodownload'  //<- this is the important bit
                    }
                  },
                  vimeo: {
                    playerOptions: {
                      controls: true,
                      interactive_markers: false,
                      interactive_params: false,
                      vimeo_logo: false,
                      play_button_position: "center",
                      progress_bar: true,
                      title: false,
                      //responsive: true
                    }
                  }
                }}
              />
            </div> 
            </>
            : ""}


            <div className='box_uploader'>
              
              {videoEtapaUpload === false ? <>El plazo para cargar tu video de la {titleFase} finalizó.</> : ""}

              {(!startUploading && !videoEtapa && videoEtapaUpload) ? 
              <>
              <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
              <div onClick={() => {consignaEtapa && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa ? " disabled" : ""}`}>
                <p>SELECCIONAR VIDEO</p>
              </div>
              </>
              : ""}

              {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

              {videoEtapa ?
                <div className='box_video_loaded1'>
                  <div className='title'>Video {titleFase} publicado</div>
                  <div className='date'>{moment(videoEtapa.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>
                  
                  {videoEtapa?.reason_etapa1?.length ?
                  <div className='box_rejected'>
                    <div className='title'>Motivos de rechazo:</div>
                    <ul>
                      {videoEtapa.reason_etapa1.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                      {videoEtapa.reason_etapa1.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                      {videoEtapa.reason_etapa1.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                    </ul>
                    {videoEtapa.reason_description_etapa1?.length ? <div className='reason_description'>{videoEtapa.reason_description_etapa1}</div> : ""}
                  </div>
                  :
                  !videoEtapa.arrpove_etapa1 ?
                    textDateFase && <div className='text_pending'>{textDateFase}</div> : ""
                  }

                  {videoEtapa.arrpove_etapa1 ? 
                    <div className='box_approved'>Tu video fue aprobado</div>
                  : "" }

                  <div className='box_video_guide_etapa1'>
                    <ReactPlayer
                      ref={_player}
                      className={`react-player`}
                      playing={false}
                      url={`https://vimeo.com/${videoEtapa.video_id}`}
                      width='100%'
                      height='100%'
                      controls={true}
                      onProgress={(progress) => { !consignaEtapa && handleVideoProgress(progress, etapaActiva)}}
                      onReady={handleOnReady}
                      onPlay={handleVideoPlay}
                      onStart={handleVideoStart}
                      onStop={handleVideoStop}
                      onEnded={handleVideoEnded}
                      onSeek={handleVideoSeek}
                      config={{ 
                        file: {
                          attributes: {
                            controlsList: 'nodownload'  //<- this is the important bit
                          }
                        },
                        vimeo: {
                          playerOptions: {
                            controls: true,
                            interactive_markers: false,
                            interactive_params: false,
                            vimeo_logo: false,
                            play_button_position: "center",
                            progress_bar: true,
                            title: false,
                            //responsive: true
                          }
                        }
                      }}
                    />
                  </div>
                  <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                </div>
              : "" }

              {(!startUploading && selectedVideo) ?
              <div className='file_data'>
                <div className='name'>
                  <div className='label'>Nombre del archivo:</div>
                  <div className='value'>{fileName}</div>
                </div>
                <div className='size'>
                  <div className='label'>Peso del archivo:</div>
                  <div className='value'>{fileSize}</div>
                </div>
              </div> 
              : ""}

              {(!startUploading && selectedVideo) ?
              <div onClick={() => handleUpload(etapaActiva)} className={`bt_gray bt_upload_file${!selectedVideo ? " disabled" : "" }`}>
                <p>SUBÍ TU VIDEO</p>
              </div>
              : ""}

              {startUploading ?
              <div className='data_progress'>
                <div className='progress_text'>
                  <div className='label'>Progreso de subida:</div>
                  <div className='value'>{uploadProgress}%</div>
                </div>
                
                <div className='video_upload_response'>{uploadStatus}</div>
                <div className='video_upload_response'>Estado: {uploadUiState} | Cliente: {clientPercent}% | Vimeo: {vimeoPercent}%</div>
                {uploadUiState === 'failed' && uploadErrorMessage ? <div className='video_upload_response'>{uploadErrorMessage}</div> : ""}
                {(uploadUiState === 'uploading' || uploadUiState === 'processing') ?
                <div onClick={handleCancelUpload} className='bt_gray bt_upload_file'>
                  <p>CANCELAR SUBIDA</p>
                </div>
                : ""}

                {isLoadingVideo ? <div className='loaging'><CircularProgress size={25} /></div> : ""}
              </div> : ""}

            </div>
          </div>

          

        </div>
        
      : ""} */}

      {/* END BLOQUE CARGA VIDEO ETAPA 1 */}








      






      {/* INI BLOQUE CARGA VIDEO ETAPA 2 */}

      {!showPresentation && whatShow === 'uploader' ?
      
        <div className='box_upload_video_etapa1'>
          <div className='upload_video_text'>{upload_video_text}</div>
          {upload_video_text1.length ? <div className='upload_video_text1'>{upload_video_text1}</div> : ""}
          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          <div className='inner'>

            {!conditionsViewedEtapa && videoEtapaUpload === true ?
            <div className='video_block'>
              <div className='bt_condiciones' onClick={() => handleDownloadPDF("condiciones")}>¡Preparate leyendo las condiciones para armar tu video!</div>
            </div> : ""}

            {!videoEtapa ?
            <>
            <div className='box_video_guide_etapa1'>
              <ReactPlayer
                ref={_player}
                className={`react-player`}
                playing={false}
                url={video_consigna_fase_url}
                width='100%'
                height='100%'
                controls={true}
                onProgress={(progress) => { !consignaEtapa && handleVideoProgress(progress, etapaActiva)}}
                onReady={handleOnReady}
                onPlay={handleVideoPlay}
                onStart={handleVideoStart}
                onStop={handleVideoStop}
                onEnded={handleVideoEnded}
                onSeek={handleVideoSeek}
                config={{ 
                  file: {
                    attributes: {
                      controlsList: 'nodownload'  //<- this is the important bit
                    }
                  },
                  vimeo: {
                    playerOptions: {
                      controls: true,
                      interactive_markers: false,
                      interactive_params: false,
                      vimeo_logo: false,
                      play_button_position: "center",
                      progress_bar: true,
                      title: false,
                      //responsive: true
                    }
                  }
                }}
              />
            </div> 
            </>
            : ""}

{/* 
VideoEtapa (false)
VideoEtapaUpload (true) 
*/}
            <div className='box_uploader'>
              
              {videoEtapaUpload === false ? <>El plazo para cargar tu video de la {titleFase} finalizó.</> : ""}

              {(!startUploading && !videoEtapa && videoEtapaUpload) ? 
              <>
              <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
              <div onClick={() => {consignaEtapa && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa ? " disabled" : ""}`}>
                <p>SELECCIONAR VIDEO</p>
              </div>
              </>
              : ""}

              {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

              {videoEtapa ?
                <div className='box_video_loaded1'>
                  <div className='title'>Video {titleFase} publicado</div>
                  <div className='date'>{moment(videoEtapa.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>
                  
                  {videoEtapa?.reason_etapa2?.length ?
                  <div className='box_rejected'>
                    <div className='title'>Motivos de rechazo:</div>
                    {/* <ul>
                      {videoEtapa.reason_etapa2.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                      {videoEtapa.reason_etapa2.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                      {videoEtapa.reason_etapa2.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                    </ul> */}
                    <ul>
                      {videoEtapa.reason_etapa2?.includes("emulsion_de_leche") ? <li><RxDotFilled /> <div>Emulsión de la leche</div></li> : ""}
                      {videoEtapa.reason_etapa2?.includes("oratoria_y_transmision_al_equipo") ? <li><RxDotFilled /> Oratoria, explicación y calidad de video</li> : ""}
                      {videoEtapa.reason_etapa2?.includes("latte_art") ? <li><RxDotFilled /> Latte Art</li> : ""}
                    </ul>
                    {videoEtapa.reason_description_etapa2?.length ? <div className='reason_description'>{videoEtapa.reason_description_etapa2}</div> : ""}
                  </div>
                  :
                  !videoEtapa.arrpove_etapa2 ?
                    textDateFase && <div className='text_pending'>{textDateFase}</div> : ""
                  }

                  {videoEtapa.arrpove_etapa2 ? 
                    <div className='box_approved'>Tu video fue aprobado</div>
                  : "" }

                  <div className='box_video_guide_etapa1'>
                    <ReactPlayer
                      ref={_player}
                      className={`react-player`}
                      playing={false}
                      url={`https://vimeo.com/${videoEtapa.video_id}`}
                      width='100%'
                      height='100%'
                      controls={true}
                      onProgress={(progress) => { !consignaEtapa && handleVideoProgress(progress, etapaActiva)}}
                      onReady={handleOnReady}
                      onPlay={handleVideoPlay}
                      onStart={handleVideoStart}
                      onStop={handleVideoStop}
                      onEnded={handleVideoEnded}
                      onSeek={handleVideoSeek}
                      config={{ 
                        file: {
                          attributes: {
                            controlsList: 'nodownload'  //<- this is the important bit
                          }
                        },
                        vimeo: {
                          playerOptions: {
                            controls: true,
                            interactive_markers: false,
                            interactive_params: false,
                            vimeo_logo: false,
                            play_button_position: "center",
                            progress_bar: true,
                            title: false,
                            //responsive: true
                          }
                        }
                      }}
                    />
                  </div>
                  <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                </div>
              : "" }

              {(!startUploading && selectedVideo) ?
              <div className='file_data'>
                <div className='name'>
                  <div className='label'>Nombre del archivo:</div>
                  <div className='value'>{fileName}</div>
                </div>
                <div className='size'>
                  <div className='label'>Peso del archivo:</div>
                  <div className='value'>{fileSize}</div>
                </div>
              </div> 
              : ""}

              {(!startUploading && selectedVideo) ?
              <div onClick={() => handleUpload(etapaActiva)} className={`bt_gray bt_upload_file${!selectedVideo ? " disabled" : "" }`}>
                <p>SUBÍ TU VIDEO</p>
              </div>
              : ""}

              {startUploading ?
              <div className='data_progress'>
                <div className='progress_text'>
                  <div className='label'>Progreso de subida:</div>
                  <div className='value'>{uploadProgress}%</div>
                </div>
                
                <div className='video_upload_response'>{uploadStatus}</div>
                <div className='video_upload_response'>Estado: {uploadUiState} | Cliente: {clientPercent}% | Vimeo: {vimeoPercent}%</div>
                {uploadUiState === 'failed' && uploadErrorMessage ? <div className='video_upload_response'>{uploadErrorMessage}</div> : ""}
                {(uploadUiState === 'uploading' || uploadUiState === 'processing') ?
                <div onClick={handleCancelUpload} className='bt_gray bt_upload_file'>
                  <p>CANCELAR SUBIDA</p>
                </div>
                : ""}

                {isLoadingVideo ? <div className='loaging'><CircularProgress size={25} /></div> : ""}
              </div> : ""}

            </div>
          </div>

          

        </div>
        
      : ""}

      {/* END BLOQUE CARGA VIDEO ETAPA 2 */}
















      {/* {!showPresentation && user.role === "experto" && scope !== "vote" ? */}
      {/* {!showPresentation && user.role === "experto" && scope !== "vote" ?
        user.is_barista ?
        <div className='box_upload_video_etapa1'>
          <div className='upload_video_text'>¡Bienvenidos Expertos a la Copa Barista 2025!</div>

          <div className='actions'>
            <div className='bt_gray bt_instructivo' onClick={() => handleDownloadPDF("instructivo")}>
              <p>Instructivo</p>
            </div>
            <div className='bt_gray bt_reglamento' onClick={() => handleDownloadPDF("reglamento")}>
              <p>Reglamento</p>
            </div>
            <div className='bt_gray bt_faq' onClick={() => handleDownloadPDF("faq")}>
              <p>Preguntas Frecuentes</p>
            </div>
          </div>

          <div className='inner'>

            {!conditionsViewedEtapa1 && videoEtapa1Upload === true ?
            <div className='video_block'>
              <div className='bt_condiciones' onClick={() => handleDownloadPDF("condiciones")}>¡Preparate leyendo las condiciones para armar tu video!</div>
            </div> : ""}

            {!videoEtapa1 ?
            <>
            <div className='box_video_guide_etapa1'>
              <ReactPlayer
                ref={_player}
                className={`react-player`}
                playing={false}
                url={"https://vimeo.com/1115536829"}
                width='100%'
                height='100%'
                controls={true}
                onProgress={(progress) => { !consignaEtapa1 && handleVideoProgress(progress, etapaActiva)}}
                onReady={handleOnReady}
                onPlay={handleVideoPlay}
                onStart={handleVideoStart}
                onStop={handleVideoStop}
                onEnded={handleVideoEnded}
                onSeek={handleVideoSeek}
                config={{ 
                  file: {
                    attributes: {
                      controlsList: 'nodownload'  //<- this is the important bit
                    }
                  },
                  vimeo: {
                    playerOptions: {
                      controls: true,
                      interactive_markers: false,
                      interactive_params: false,
                      vimeo_logo: false,
                      play_button_position: "center",
                      progress_bar: true,
                      title: false,
                      //responsive: true
                    }
                  }
                }}
              />
            </div> 
            </>
            : ""}


            <div className='box_uploader'>
              
              {videoEtapa1Upload === false ? <>El plazo para cargar tu video de la {titleFase} finalizó.</> : ""}

              {(!startUploading && !videoEtapa1 && videoEtapa1Upload) ? 
              <>
              <HiddenInput type="file" name="video" ref={fileInputRef} onChange={handleVideoChange} />
              <div onClick={() => {consignaEtapa1 && handleButtonBrowserClick()}} className={`bt_gray bt_select_file${!consignaEtapa1 ? " disabled" : ""}`}>
                <p>SELECCIONAR VIDEO</p>
              </div>
              </>
              : ""}

              {errorVideosize.length ? <div className='error_video_size'>{errorVideosize}</div> : ""}

              {videoEtapa1 ?
                <div className='box_video_loaded1'>
                  <div className='title'>Video {titleFase} publicado</div>
                  <div className='date'>{moment(videoEtapa1.created_at).format("DD/MM/yyyy HH:mm:ss")}</div>
                  
                  {videoEtapa1?.reason_etapa1?.length ?
                  <div className='box_rejected'>
                    <div className='title'>Motivos de rechazo:</div>
                    <ul>
                      {videoEtapa1.reason_etapa1.includes("espresso_perfecto") ? <li><RxDotFilled /> <div>Espresso Perfecto</div></li> : ""}
                      {videoEtapa1.reason_etapa1.includes("presentacion_personal") ? <li><RxDotFilled /> Presentación Personal</li> : ""}
                      {videoEtapa1.reason_etapa1.includes("especificaciones_tecnicas") ? <li><RxDotFilled /> Especificaciones Técnicas</li> : ""}
                    </ul>
                    {videoEtapa1.reason_description_etapa1?.length ? <div className='reason_description'>{videoEtapa1.reason_description_etapa1}</div> : ""}
                  </div>
                  :
                  !videoEtapa1.arrpove_etapa1 ?
                    <div className='text_pending'>{textDateFase}</div> : ""
                  }

                  {videoEtapa1.arrpove_etapa1 ? 
                    <div className='box_approved'>Tu video fue aprobado</div>
                  : "" }

                  <div className='box_video_guide_etapa1'>
                    <ReactPlayer
                      ref={_player}
                      className={`react-player`}
                      playing={false}
                      url={`https://vimeo.com/${videoEtapa1.video_id}`}
                      width='100%'
                      height='100%'
                      controls={true}
                      onProgress={(progress) => { !consignaEtapa1 && handleVideoProgress(progress, etapaActiva)}}
                      onReady={handleOnReady}
                      onPlay={handleVideoPlay}
                      onStart={handleVideoStart}
                      onStop={handleVideoStop}
                      onEnded={handleVideoEnded}
                      onSeek={handleVideoSeek}
                      config={{ 
                        file: {
                          attributes: {
                            controlsList: 'nodownload'  //<- this is the important bit
                          }
                        },
                        vimeo: {
                          playerOptions: {
                            controls: true,
                            interactive_markers: false,
                            interactive_params: false,
                            vimeo_logo: false,
                            play_button_position: "center",
                            progress_bar: true,
                            title: false,
                            //responsive: true
                          }
                        }
                      }}
                    />
                  </div>
                  <div className='aclaration'>Si no puedes visualizar el video, es posible que el proceso de optimización esté en curso y pueda tardar <span className='highlight'>unas horas</span>. Si después de ese tiempo aún no puedes verlo, por favor contáctanos a <span className='highlight'>contacto@somosprotagonistas.com.ar</span>.</div>

                </div>
              : "" }

              {(!startUploading && selectedVideo) ?
              <div className='file_data'>
                <div className='name'>
                  <div className='label'>Nombre del archivo:</div>
                  <div className='value'>{fileName}</div>
                </div>
                <div className='size'>
                  <div className='label'>Peso del archivo:</div>
                  <div className='value'>{fileSize}</div>
                </div>
              </div> 
              : ""}

              {(!startUploading && selectedVideo) ?
              <div onClick={() => handleUpload(etapaActiva)} className={`bt_gray bt_upload_file${!selectedVideo ? " disabled" : "" }`}>
                <p>SUBÍ TU VIDEO</p>
              </div>
              : ""}

              {startUploading ?
              <div className='data_progress'>
                <div className='progress_text'>
                  <div className='label'>Progreso de subida:</div>
                  <div className='value'>{uploadProgress}%</div>
                </div>
                
                <div className='video_upload_response'>{uploadStatus}</div>
                <div className='video_upload_response'>Estado: {uploadUiState} | Cliente: {clientPercent}% | Vimeo: {vimeoPercent}%</div>
                {uploadUiState === 'failed' && uploadErrorMessage ? <div className='video_upload_response'>{uploadErrorMessage}</div> : ""}
                {(uploadUiState === 'uploading' || uploadUiState === 'processing') ?
                <div onClick={handleCancelUpload} className='bt_gray bt_upload_file'>
                  <p>CANCELAR SUBIDA</p>
                </div>
                : ""}

                {isLoadingVideo ? <div className='loaging'><CircularProgress size={25} /></div> : ""}
              </div> : ""}

            </div>
          </div>

          

        </div>
        :
        <div className='box_voting_pending'>
          <div className='inner'>
            <div className='text'>
              Próximamente vas a poder votar a tu Barista favorito
            </div>
          </div>
        </div>
      : ""} */}
      
    </WrappedStyled>
  );
};

export default BaristasContainer;